<template>
  <div class="v_info_x my-wrapper">
    <div class="v_info">
      <div v-if="operate === 'detail' && status !== 4" class="detail-qrcode">
        <div class="qrimg-x">
          <div id="qrImg" class="qrImg">
            <!-- <canvas id="canvas"></canvas> -->
          </div>
        </div>
        <div class="success-code">预约码：{{ appointmentCode }}</div>
        <div class="success-tip">
          该访客的预约码如上，请截图或长按保存告知该访客，方便其登记进入，或访客可通过手机号查询自己的预约码
        </div>
        <div class="bottom-tip">
          <hua-notice-bar
              :scrollable="false"
              text="长按或截图保存，避免丢失"
              left-icon="info-o"
              background="#fff4e6"
              color="#ff7514"
          >
            <template slot="left-icon">
              <hua-icon
                  name="info"
                  color="#ff6a00"
                  size="16px"
                  class="slot-icon"
              ></hua-icon>
            </template
            >
          </hua-notice-bar>
        </div>
      </div>
      <hua-form @submit="utils.debounce(onSubmit, 1000)" :label-width="90" :input-align="'right'">
        <!-- 被访人员信息 -->
        <div class="info_title icon-title">
            <img src="@/image/jzgyy_pic_msg1.png" alt="">
            {{ tabsList[0].label }}
        </div>
        <!-- <div v-if="showTab == '1'">
          <hua-field :readonly="true" :label="formFields.departmentId.label"
           v-model="formFields.departmentId.text"
          :right-icon="isEdit ? '' : 'arrow' " :placeholder="formFields.departmentId.placeholder"
          @click-right-icon="isEdit ? '': (formFields.departmentId.showPicker = true)" required>
        </hua-field>
        <hua-popup v-model="formFields.departmentId.showPicker" position="bottom">
            <hua-cascader
              :value="formFields.departmentId.value"
              title="请选择所属部门"
              :options="treeDataList"
              @close="formFields['departmentId'].showPicker = false"
              @finish="onCascaderFinish"
              @change="departmentChange"
            />
        </hua-popup>
        <hua-field
            key="field11"
            readonly
            clickable
            name="picker"
            :label="formFields['field28'].label"
            :required="formFields['field28'].require"
            :rules="formFields['field28'].rules"
            :value="formFields['field28'].text"
            :placeholder="formFields['field28'].placeholder"
            :right-icon="isEdit ? '' : 'arrow' "
            @click-right-icon="isEdit ? '' : canClick()"
        >
        </hua-field>
        <hua-popup v-model="formFields['field28'].showPicker" round position="bottom">
          <hua-picker
              key="field12"
              show-toolbar
              :columns="formFields['field28'].columns"
              :default-index="formFields['field28'].defaultIndex"
              @confirm="formFields['field28'].confirm"
              @cancel="formFields['field28'].showPicker = false"
          />
        </hua-popup>
        </div> -->
        <!-- 工号 -->
        <div class="form-block" v-if="showTab == '2'">
          <hua-field
            style="margin: 0 10px;width: calc(100% - 20px);border-radius: 10px 10px 0 0"
            key="field29"
            clearable
            type="number"
            label="工号"
            :required="isIntervieweeRequired"
            :maxLength="formFields['field29'].maxLength"
            :readonly="!!v_personid || !!id || isEdit"
            :rules="formFields['field29'].rules"
            v-model="formFields['field29'].value"
            @input="formFields['field29'].change"
            :placeholder="!!id ? ' ' : formFields['field29'].placeholder"
        >
          <!-- 邀约 -->
          <template #button v-if="v_personid && !id && formFields['field29'].value">
            <hua-radio/>
          </template>
          <!-- 查看、审核 -->
          <template v-else-if="id && operate"></template>
          <!-- 预约 -->
          <template #right-icon v-else>
                        <span>
                            <hua-icon
                                name="search"
                                :class="[searchDisabled ? 'disableSearch' : 'activeSearch']"
                                @click="formFields['field29'].search"
                            />
                        </span>
          </template>
        </hua-field>
        <div class="info_tip" v-if="v_personid && !id && !formFields['field29'].value">
          *您无法邀约，请先前往“人员管理”维护被访人员手机号码
        </div>
        <!-- 被访人员姓名 field2-->
          <div class="form-block" style="border-radius: 0 0 10px 10px">
        <hua-field
            key="field30"
            readonly
            type="text"
            clickable
            :label="formFields['field30'].label"
            :required="isIntervieweeRequired"
            :rules="formFields['field30'].rules"
            v-model="formFields['field30'].text"
            :placeholder="!!id ? ' ' : formFields['field30'].placeholder"
        />
          </div>
        </div>
        <!-- 部门 -->
        <div class="form-block" v-else-if="showTab == '1'">
          <hua-field :readonly="true" :label="formFields.departmentId.label"
            v-model="formFields.departmentId.text"
            required>
            <!-- 邀约 -->
            <template #button v-if="v_personid && !id && formFields['field29'].value">
                <hua-radio/>
            </template>
            <!-- 查看、审核 -->
            <template v-else-if="id && operate"></template>
            <!-- 预约 -->
            <template #right-icon v-else>
                <span>
                    <hua-icon
                        name="arrow"
                        :right-icon="isEdit ? '' : 'arrow' " :placeholder="formFields.departmentId.placeholder"
                        @click-right-icon="isEdit ? '': (formFields.departmentId.showPicker = true)"
                    />
                </span>
            </template>
          </hua-field>
            <hua-popup v-model="formFields.departmentId.showPicker" position="bottom">
                <hua-cascader
                :value="formFields.departmentId.value"
                title="请选择所属部门"
                :options="treeDataList"
                @close="formFields['departmentId'].showPicker = false"
                @finish="onCascaderFinish"
                @change="departmentChange"
                />
            </hua-popup>
            <hua-field
                key="field11"
                readonly
                clickable
                name="picker"
                :label="formFields['field28'].label"
                :required="formFields['field28'].require"
                :rules="formFields['field28'].rules"
                :value="formFields['field28'].text"
                :placeholder="formFields['field28'].placeholder"
                :right-icon="isEdit ? '' : 'arrow' "
                @click="isEdit ? '' : canClick()"
            >
            </hua-field>
            <hua-popup v-model="formFields['field28'].showPicker" round position="bottom">
            <hua-picker
                key="field12"
                show-toolbar
                :columns="formFields['field28'].columns"
                :default-index="formFields['field28'].defaultIndex"
                @confirm="formFields['field28'].confirm"
                @cancel="formFields['field28'].showPicker = false"
            />
            </hua-popup>
        </div>
        <!-- 手机号码 field1-->
        <div class="form-block" v-else>
          <hua-field
            key="field1"
            clearable
            type="number"
            label="手机号码"
            :maxLength="formFields['field1'].maxLength"
            :required="isIntervieweeRequired"
            :readonly="!!v_personid || !!id || isEdit"
            :rules="formFields['field1'].rules"
            v-model="formFields['field1'].value"
            @input="formFields['field1'].change"
            :placeholder="!!id ? ' ' : formFields['field1'].placeholder"
        >
          <!-- 邀约 -->
          <template #button v-if="v_personid && !id && formFields['field1'].value">
            <hua-radio/>
          </template>
          <!-- 查看、审核 -->
          <template v-else-if="id && operate"></template>
          <!-- 预约 -->
          <template #right-icon v-else>
                        <span>
                            <hua-icon
                                name="search"
                                :class="[searchDisabled ? 'disableSearch' : 'activeSearch']"
                                @click="formFields['field1'].search"
                            />
                        </span>
          </template>
        </hua-field>
        <div class="info_tip" v-if="v_personid && !id && !formFields['field1'].value">
          *您无法邀约，请先前往“人员管理”维护被访人员手机号码
        </div>
        <!-- 被访人员姓名 field2-->
        <hua-field
            key="field2"
            readonly
            type="text"
            clickable
            :label="formFields['field2'].label"
            :required="isIntervieweeRequired"
            v-model="formFields['field2'].text"
            :placeholder="!!id ? ' ' : formFields['field2'].placeholder"
        />
        </div>



        <!-- 来访信息 -->
        <div class="info_title icon-title">
            <img src="@/image/jzgyy_pic_msg2.png" alt="">
            {{ tabsList[1].label }}
        </div>
        <!-- 访问类型 field3-->
        <div class="form-block">
        <hua-field
            key="field3"
            name="picker"
            class="visitType"
            readonly
            :value="formFields['field3'].text"
            :rules="formFields['field3'].rules"
            :label="formFields['field3'].label"
            :right-icon="!!id || isEdit ? '' : 'arrow'"
            @click="isEdit ? '': (formFields.field3.showPicker = true)"
        >
        </hua-field>
        <!-- 来访时间 field4-->
        <hua-field
            key="field4"
            name="picker"
            readonly
            clickable
            required
            :right-icon="!!id || isEdit ? '' : 'arrow'"
            :label="formFields['field4'].label"
            :rules="formFields['field4'].rules"
            :value="formFields['field4'].value ? formFields['field4'].value : onConfirmArriveTime (formFields['field4'].currentDate)"
            :placeholder="formFields['field4'].placeholder"
            @click="!!id || isEdit ? '' : arriveClick()"
        />
        <hua-popup v-model="formFields['field4'].showPicker" round position="bottom">
          <!-- type="date" -->
          <hua-datetime-picker
              key="field8"
              type="datetime"
              title="来访时间"
              :readonly='isEdit'
              :min-date="formFields['field4'].minDate"
              :max-date="formFields['field4'].maxDate"
              v-model="formFields['field4'].currentDate"
              @confirm="onConfirmArriveTime"
              @cancel="formFields['field4'].showPicker = false"
          />
        </hua-popup>
        <!-- 离访时间 field5-->
        <hua-field
            key="field9"
            name="picker"
            clickable
            required
            :readonly='isEdit'
            :right-icon="!!id || isEdit ? '' : 'arrow'"
            :label="formFields['field5'].label"
            :rules="formFields['field5'].rules"
            :value="formFields['field5'].value ? formFields['field5'].value : onConfirmleaveTime (new Date(new Date(new Date().toLocaleDateString()).getTime() + (22 * 60 * 60 * 1000)))"
            :placeholder="formFields['field5'].placeholder"
            @click="!!id || isEdit ? '' : leaveClick()"
        />
        <hua-popup v-model="formFields['field5'].showPicker" round position="bottom">
          <hua-datetime-picker
              key="field10"
              type="datetime"
              title="离访时间"
              :min-date="formFields['field5'].minDate"
              :max-date="formFields['field5'].maxDate"
              v-model="formFields['field5'].currentDate"
              @confirm="onConfirmleaveTime"
              @cancel="formFields['field5'].showPicker = false"
          />
        </hua-popup>
        <!-- 访客类型 field6-->
        <hua-field
            key="field11"
            readonly
            clickable
            name="picker"
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field6'].label"
            :required="formFields['field6'].require"
            :rules="formFields['field6'].rules"
            :value="formFields['field6'].text"
            :placeholder="formFields['field6'].placeholder"
            @click="formFields['field6'].showPicker = true"
        >
        </hua-field>
        <hua-popup v-model="formFields['field6'].showPicker" round position="bottom">
          <hua-picker
              key="field12"
              show-toolbar
              :columns="formFields['field6'].columns"
              :default-index="formFields['field6'].defaultIndex"
              @confirm="formFields['field6'].confirm"
              @cancel="formFields['field6'].showPicker = false"
          />
        </hua-popup>
        <!-- 访问次数field7 v-if="!isOrder"-->
        <hua-field
            v-if="false"
            key="field13"
            clearable
            :readonly="isNoBtn"
            :type="formFields['field7'].type"
            :label="formFields['field7'].label"
            :required="formFields['field7'].require"
            :rules="formFields['field7'].rules"
            v-model="formFields['field7'].value"
            :placeholder="formFields['field7'].placeholder"
        >
          <template v-slot:extra> {{ formFields['field7'].extra }}</template>
        </hua-field>
        <!-- 访客区域 field18-->
        <!-- v-if="v_personid || id" -->
        <hua-field
            key="field25"
            :right-icon="isNoBtn ? '' : 'arrow'"
            readonly
            :type="formFields['field18'].type"
            :label="formFields['field18'].label"
            :required="formFields['field18'].require"
            :rules="formFields['field18'].rules"
            v-model="formFields['field18'].value"
            :placeholder="formFields['field18'].placeholder"
            @click="formFields['field18'].showPicker = true"
        />
        <hua-popup v-model="formFields['field18'].showPicker" position="bottom" round @close="closeAreaPopup">
          <div class="customContent">
            <div class="area-content-title">
              <div @click="closeAreaPopup">取消</div>
              <div>访问区域</div>
              <div @click="areaChange">确定</div>
            </div>
            <hua-checkbox-group v-model="areaIdListTemp">
              <hua-cell-group>
                <hua-cell
                    clickable
                    v-for="item in formFields['field18'].areaList"
                    :key="item.value"
                    :title="item.text"
                >
                  <template #right-icon>
                    <hua-checkbox ref="checkboxes" :name="item.value"/>
                  </template>
                </hua-cell>
              </hua-cell-group>
            </hua-checkbox-group>
          </div>
        </hua-popup>
        <!-- 来访事由field8 -->
        <hua-field
            class="visit-reason"
            key="field14"
            clearable
            :readonly="!!id"
            :type="formFields['field8'].type"
            :label="formFields['field8'].label"
            :required="formFields['field8'].require"
            :rules="formFields['field8'].rules"
            :maxLength="formFields['field8'].maxLength"
            v-model="formFields['field8'].value"
            :placeholder="!!id ? ' ' : formFields['field8'].placeholder"
        />
        </div>
        <!-- 访客信息 -->
        <div class="info_title icon-title">
            <img src="@/image/jzgyy_pic_msg3.png" alt="">
            {{ tabsList[2].label }}
        </div>
        <div class="form-block">
        <!-- 来访人数field9 -->
        <hua-field
            key="field15"
            clearable
            :readonly="visitorMode == 1 || !!id || isEdit"
            :type="formFields['field9'].type"
            :label="formFields['field9'].label"
            :required="formFields['field9'].require"
            :rules="formFields['field9'].rules"
            v-model="formFields['field9'].value"
            :placeholder="formFields['field9'].placeholder"
            @blur="!!id ? '' : visitorNumBlur($event)"
        />
        <!-- 访客姓名 field10-->
        <hua-field
            key="field16"
            clearable
            :readonly="!!id"
            :type="formFields['field10'].type"
            :label="formFields['field10'].label"
            :rules="formFields['field10'].rules"
            :required="formFields['field10'].require"
            :maxLength="formFields['field10'].maxLength"
            v-model="formFields['field10'].value"
            :placeholder="formFields['field10'].placeholder"
        >
          <!-- <template v-slot:label>
              {{ formFields['field10'].label }}
              <hua-tag
                  v-if="formFields['field10'].isInner !== null"
                  marketing
                  :type="'primary'"
                  >{{ formFields['field10'].isInner ? '内部' : '外部' }}</hua-tag
              >
          </template> -->
        </hua-field>

        <!-- 联系电话field12 -->
        <hua-field
            clearable
            key="field19"
            :maxLength="formFields['field12'].maxLength"
            :readonly="!!id || isEdit"
            :type="formFields['field12'].type"
            :label="formFields['field12'].label"
            :required="formFields['field12'].require"
            :rules="formFields['field12'].rules"
            v-model="formFields['field12'].value"
            :placeholder="formFields['field12'].placeholder"
        />
        <!-- 人脸照片 field11-->
        <hua-field
            class="face-img"
            clickable
            name="text"
            :required="formFields['field11'].require"
            :rules="formFields['field11'].rules"
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field11'].label"
            :value="formFields['field11'].value"
        >
           <template v-slot:input>
            <hua-uploader
                accept="image/*"
                key="field18"
                max-count="1"
                :readonly="!!id"
                :deletable="!id"
                :before-read="(file) => uploadIntercept(file, 'field11')"
                v-model="formFields['field11'].fileList"
                @delete="deleteImg($event, 'field11')"
            />
            <div v-if="(timeType == '1' && !shortTermSwitch) || (timeType == '2' && !longTermSwitch)" class="img-tips">
                {{"(提示：" + imageTipContent + ")"}}
            </div>
          </template>
        </hua-field>


        <!-- 车牌号码 field17-->
        <hua-field
            v-if="showPlateNumber"
            key="field20"
            class="carNumber"
            clearable
            :readonly="!!id"
            :label="formFields['field17'].label"
            :required="formFields['field17'].require"
            :rules="formFields['field17'].rules"
            v-model="formFields['field17'].value"
            :maxLength="formFields['field17'].maxLength"
            :placeholder="!!id ? ' ' : formFields['field17'].placeholder"
        />
        <!-- 是否收费 -->
        <!-- v-if="formFields['field17'].value && formFields['field17'].value.trim()" -->
        <hua-field
            key="field24"
            clickable
            readonly
            name="picker"
            v-if="false"
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field24'].label"
            :required="formFields['field24'].require"
            :rules="formFields['field24'].rules"
            :value="formFields['field24'].text"
            :placeholder="formFields['field24'].placeholder"
            @click="!!id ? '' : (formFields['field24'].showPicker = true)"
        >
        </hua-field>
        <hua-popup v-model="formFields['field24'].showPicker" round position="bottom">
          <hua-picker
              key="field25"
              show-toolbar
              :columns="formFields['field24'].columns"
              :default-index="formFields['field24'].defaultIndex"
              @confirm="formFields['field24'].confirm"
              @cancel="formFields['field24'].showPicker = false"
          />
        </hua-popup>
        <!-- 免费时长 1-24-->
        <hua-field
            key="field26"
            clickable
            readonly
            name="picker"
            v-if="formFields['field24'].text === '是'"
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field26'].label"
            :required="formFields['field26'].require"
            :rules="formFields['field26'].rules"
            :value="formFields['field26'].text"
            :placeholder="formFields['field26'].placeholder"
            @click="!!id ? '' : (formFields['field26'].showPicker = true)"
        >
        </hua-field>
        <hua-popup v-model="formFields['field26'].showPicker" round position="bottom">
          <hua-picker
              key="field27"
              show-toolbar
              :columns="formFields['field26'].columns"
              :default-index="formFields['field26'].defaultIndex"
              @confirm="formFields['field26'].confirm"
              @cancel="formFields['field26'].showPicker = false"
          />
        </hua-popup>
        <!-- 证件类型field13 -->
        <hua-field
            key="field21"
            clickable
            readonly
            name="picker"
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field13'].label"
            :required="formFields['field13'].require"
            :rules="formFields['field13'].rules"
            :value="formFields['field13'].value"
            :placeholder="formFields['field13'].placeholder"
            @click="!!id ? '' : (formFields['field13'].showPicker = true)"
        >
        </hua-field>
        <hua-popup v-model="formFields['field13'].showPicker" round position="bottom">
          <hua-picker
              key="field22"
              show-toolbar
              :columns="formFields['field13'].columns"
              @confirm="formFields['field13'].confirm"
              @cancel="formFields['field13'].showPicker = false"
          />
        </hua-popup>
        <!-- 证件号 field14-->
        <hua-field
            key="field23"
            clearable
            :readonly="!!id"
            :type="formFields['field14'].type"
            :label="formFields['field14'].label"
            :required="formFields['field14'].require"
            :maxLength="formFields['field14'].maxLength"
            :rules="formFields['field14'].rules"
            v-model="formFields['field14'].value"
            :placeholder="!!id ? ' ' : formFields['field14'].placeholder"
            @focus="!!id ? '' : idFieldFocus('field13')"
        />
        <!-- 来访单位field15 -->
        <hua-field
            clearable
            :readonly="!!id"
            :type="formFields['field15'].type"
            :label="formFields['field15'].label"
            :required="formFields['field15'].require"
            :maxLength="formFields['field15'].maxLength"
            :rules="formFields['field15'].rules"
            v-model="formFields['field15'].value"
            :placeholder="!!id ? ' ' : formFields['field15'].placeholder"
        />
        <!-- 访客住址field16 -->
        <!-- <hua-field
            clearable
            :readonly="!!id"
            :type="formFields['field16'].type"
            :label="formFields['field16'].label"
            :required="formFields['field16'].require"
            :maxLength="formFields['field16'].maxLength"
            :rules="formFields['field16'].rules"
            v-model="formFields['field16'].value"
            :placeholder="!!id ? ' ' : formFields['field16'].placeholder"
        /> -->
        <hua-field
            clearable
            v-if="id && operate === 'audit' && reviewable"
            :type="formFields['field33'].type"
            :label="formFields['field33'].label"
            :required="formFields['field33'].require"
            :maxLength="formFields['field33'].maxLength"
            :rules="formFields['field33'].rules"
            v-model="formFields['field33'].value"
            :placeholder="!!id ? ' ' : formFields['field33'].placeholder"
        />
        </div>


        <!-- 新增随访人员 -->
        <div v-if="isFollowerRequired" :style="{'margin-bottom': 20 + 'px'}">
          <template v-for="(item, index) in followFormList">
            <!-- 随访人员 -->
            <div class="followSpace" :key="'fieldf' + index + 1 + '1388'"></div>
            <div class="form-block">
            <hua-field
                clearable
                :readonly="!!id"
                :key="'fieldf' + (index + 1) + '1311'"
                :type="item['fieldf' + (index + 1) + 1].type"
                :label="item['fieldf' + (index + 1) + 1].label + item.id"
                :required="item['fieldf' + (index + 1) + 1].require"
                :maxLength="item['fieldf' + (index + 1) + 1].maxLength"
                :rules="item['fieldf' + (index + 1) + 1].rules"
                v-model="item['fieldf' + (index + 1) + 1].value"
                :placeholder="item['fieldf' + (index + 1) + 1].placeholder"
            >
              <!-- <template v-slot:label>
                  {{ item['fieldf' + (index + 1) + 1].label + item.id }}
                  <hua-tag
                      v-if="item['fieldf' + (index + 1) + 1].isInner !== null"
                      marketing
                      :type="'primary'"
                      >{{
                          item['fieldf' + (index + 1) + 1].isInner ? '内部' : '外部'
                      }}</hua-tag
                  >
              </template> -->
            </hua-field>

            <!-- 联系电话 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 3"
                clearable
                :readonly="!!id"
                type="number"
                :maxLength="item['fieldf' + (index + 1) + 3].maxLength"
                :label="item['fieldf' + (index + 1) + 3].label"
                :required="item['fieldf' + (index + 1) + 3].require"
                :rules="item['fieldf' + (index + 1) + 3].rules"
                v-model="item['fieldf' + (index + 1) + 3].value"
                :placeholder="item['fieldf' + (index + 1) + 3].placeholder"
            />
            <!-- 人脸照片 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 2 + '1312'"
                readonly
                clickable
                name="text"
                :required="imageYesOrNo"
                :right-icon="!!id ? '' : 'arrow'"
                :label="item['fieldf' + (index + 1) + 2].label"
                :rules="imageRules"
                :value="item['fieldf' + (index + 1) + 2].value"
            >
              <template v-slot:input >
                <hua-uploader
                    :key="'fieldf' + (index + 1) + 21"
                    accept="image/*"
                    max-count="1"
                    :readonly="!!id"
                    :deletable="!id"
                    v-model="item['fieldf' + (index + 1) + 2].fileList"
                    :before-read="(file) => uploadIntercept(file, 'fieldf' + (index + 1) + 2)"
                    @delete="deleteImg($event, 'fieldf'+ (index + 1) + 2)"
                />
                    <!-- :after-read="(args) => handleChange(args, 'fieldf' + (index + 1) + 2)" -->
              </template>
            </hua-field>

            <!-- 车牌号码 -->
            <hua-field
                 v-if="showPlateNumber"
                :key="'fieldf' + (index + 1) + 4"
                clearable
                :label="item['fieldf' + (index + 1) + 4].label"
                :rules="item['fieldf' + (index + 1) + 4].rules"
                v-model="item['fieldf' + (index + 1) + 4].value"
                :maxLength="item['fieldf' + (index + 1) + 4].maxLength"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 4].placeholder"
            />
            <!-- 证件类型 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 5"
                readonly
                clickable
                name="picker"
                :right-icon="!!id ? '' : 'arrow'"
                :required="item['fieldf' + (index + 1) + 5].require"
                :label="item['fieldf' + (index + 1) + 5].label"
                :rules="item['fieldf' + (index + 1) + 5].rules"
                :value="item['fieldf' + (index + 1) + 5].value"
                :placeholder="item['fieldf' + (index + 1) + 5].placeholder"
                @click="
                                !!id ? '' : (item['fieldf' + (index + 1) + 5].showPicker = true)
                            "
            >
            </hua-field>
            <hua-popup
                :key="'fieldf' + (index + 1) + 51"
                v-model="item['fieldf' + (index + 1) + 5].showPicker"
                position="bottom"
            >
              <hua-picker
                  :key="'fieldf' + (index + 1) + 52"
                  show-toolbar
                  :columns="item['fieldf' + (index + 1) + 5].columns"
                  @confirm="onConfirm"
                  @cancel="item['fieldf' + (index + 1) + 5].showPicker = false"
              />
            </hua-popup>
            <!-- 证件号 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 6"
                clearable
                :readonly="!!id"
                :type="item['fieldf' + (index + 1) + 6].type"
                :label="item['fieldf' + (index + 1) + 6].label"
                :required="item['fieldf' + (index + 1) + 6].require"
                :maxLength="item['fieldf' + (index + 1) + 6].maxLength"
                :rules="item['fieldf' + (index + 1) + 6].rules"
                v-model="item['fieldf' + (index + 1) + 6].value"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 6].placeholder"
                @focus="idFieldFocus('fieldf' + (index + 1) + 5)"
            />
            <!-- 民族 -->
            <!-- <hua-field
                :key="'fieldf' + (index + 1) + 7"
                clearable
                v-if="timeType === '2'"
                :right-icon="!!id ? '' : 'arrow'"
                :type="item['fieldf' + (index + 1) + 7].type"
                :label="item['fieldf' + (index + 1) + 7].label"
                :required="item['fieldf' + (index + 1) + 7].require"
                :maxLength="item['fieldf' + (index + 1) + 7].maxLength"
                :rules="item['fieldf' + (index + 1) + 7].rules"
                v-model="item['fieldf' + (index + 1) + 7].value"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 7].placeholder"
                @click-right-icon="item['fieldf' + (index + 1) + 7].showPicker = true"
            />
            <hua-popup :key="'fieldf' + (index + 1) + 71" v-model="item['fieldf' + (index + 1) + 7].showPicker" round position="bottom">
                <hua-picker
                    :key="'fieldf' + (index + 1) + 72"
                    show-toolbar
                    :columns="item['fieldf' + (index + 1) + 7].columns"
                    :default-index="item['fieldf' + (index + 1) + 7].defaultIndex"
                    @confirm="onConfirm"
                    @cancel="item['fieldf' + (index + 1) + 7].showPicker = false"
                />
            </hua-popup> -->
            <!-- 银行卡号 -->
            <!-- <hua-field
                :key="'fieldf' + (index + 1) + 8"
                clearable
                v-if="timeType === '2'"
                :type="item['fieldf' + (index + 1) + 8].type"
                :label="item['fieldf' + (index + 1) + 8].label"
                :required="item['fieldf' + (index + 1) + 8].require"
                :maxLength="item['fieldf' + (index + 1) + 8].maxLength"
                :rules="item['fieldf' + (index + 1) + 8].rules"
                v-model="item['fieldf' + (index + 1) + 8].value"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 8].placeholder"
            /> -->
            <!-- 开户行姓名 -->
            <!-- <hua-field
                clearable
                :key="'fieldf' + (index + 1) + 9"
                v-if="timeType === '2'"
                :type="item['fieldf' + (index + 1) + 9].type"
                :label="item['fieldf' + (index + 1) + 9].label"
                :required="item['fieldf' + (index + 1) + 9].require"
                :maxLength="item['fieldf' + (index + 1) + 9].maxLength"
                :rules="item['fieldf' + (index + 1) + 9].rules"
                v-model="item['fieldf' + (index + 1) + 9].value"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 9].placeholder"
            /> -->
            </div>
          </template>
        </div>

        <!-- 审核详情随访人员 -->
        <div v-if="isApprovingRequired" :style="{'margin-bottom': 20 + 'px'}">
          <div class="info_title icon-title">
              <img src="@/image/jzgyy_pic_msg4.png" alt="">
              {{ tabsList[3].label }}
            </div>
          <template v-for="(item, index) in approvingFormList">
            <div class="form-block">
           <hua-field
              clearable
              :readonly="!!id"
              :key="'fieldf' + (index + 1) + '1311'"
              :type="item['fieldf' + (index + 1) + 1].type"
              :label="item['fieldf' + (index + 1) + 1].label"
              v-model="item['fieldf' + (index + 1) + 1].value"
              :placeholder="item['fieldf' + (index + 1) + 1].placeholder"
            >
            </hua-field>
            <!-- 联系电话 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 3"
                clearable
                :readonly="!!id"
                :label="item['fieldf' + (index + 1) + 3].label"
                v-model="item['fieldf' + (index + 1) + 3].value"
                :placeholder="item['fieldf' + (index + 1) + 3].placeholder"
            />
            <!-- 人脸照片 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 2 + '1312'"
                readonly
                clickable
                name="text"
                :required="imageYesOrNo"
                :right-icon="!!id ? '' : 'arrow'"
                :label="item['fieldf' + (index + 1) + 2].label"
                :rules="imageRules"
                :value="item['fieldf' + (index + 1) + 2].value"
            >
            </hua-field>

            <!-- 车牌号码 -->
            <hua-field
                readonly
                v-if="showPlateNumber"
                :key="'fieldf' + (index + 1) + 4"
                clearable
                :label="item['fieldf' + (index + 1) + 4].label"
                :rules="item['fieldf' + (index + 1) + 4].rules"
                v-model="item['fieldf' + (index + 1) + 4].value"
                :maxLength="item['fieldf' + (index + 1) + 4].maxLength"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 4].placeholder"
            />
            <!-- 证件类型 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 5"
                readonly
                clickable
                name="picker"
                :required="item['fieldf' + (index + 1) + 5].require"
                :right-icon="!!id ? '' : 'arrow'"
                :label="item['fieldf' + (index + 1) + 5].label"
                :rules="item['fieldf' + (index + 1) + 5].rules"
                :value="item['fieldf' + (index + 1) + 5].value"
                :placeholder="item['fieldf' + (index + 1) + 5].placeholder"
                @click="!!id ? '' : (item['fieldf' + (index + 1) + 5].showPicker = true)"
            >
            </hua-field>
            <hua-popup
                :key="'fieldf' + (index + 1) + 51"
                v-model="item['fieldf' + (index + 1) + 5].showPicker"
                position="bottom"
            >
              <hua-picker
                  :key="'fieldf' + (index + 1) + 52"
                  show-toolbar
                  :columns="item['fieldf' + (index + 1) + 5].columns"
                  @confirm="onConfirm"
                  @cancel="item['fieldf' + (index + 1) + 5].showPicker = false"
              />
            </hua-popup>
            <!-- 证件号 -->
            <hua-field
                :key="'fieldf' + (index + 1) + 6"
                clearable
                :readonly="!!id"
                :type="item['fieldf' + (index + 1) + 6].type"
                :label="item['fieldf' + (index + 1) + 6].label"
                :required="item['fieldf' + (index + 1) + 6].require"
                :maxLength="item['fieldf' + (index + 1) + 6].maxLength"
                :rules="item['fieldf' + (index + 1) + 6].rules"
                v-model="item['fieldf' + (index + 1) + 6].value"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 6].placeholder"
                @focus="idFieldFocus('fieldf' + (index + 1) + 5)"
            />
            <!-- 民族 -->
            <!-- <hua-field
                :key="'fieldf' + (index + 1) + 7"
                readonly
                clickable
                name="picker"
                v-if="timeType === '2'"
                :right-icon="!!id ? '' : 'arrow'"
                :label="item['fieldf' + (index + 1) + 7].label"
                :required="item['fieldf' + (index + 1) + 7].require"
                :rules="item['fieldf' + (index + 1) + 7].rules"
                :value="item['fieldf' + (index + 1) + 7].text"
                :placeholder="item['fieldf' + (index + 1) + 7].placeholder"
                @click-right-icon="item['fieldf' + (index + 1) + 7].showPicker = true"
            >
            </hua-field>
            <hua-popup :key="'fieldf' + (index + 1) + 71" v-model="item['fieldf' + (index + 1) + 7].showPicker" round position="bottom">
                <hua-picker
                    :key="'fieldf' + (index + 1) + 72"
                    show-toolbar
                    :columns="item['fieldf' + (index + 1) + 7].columns"
                    :default-index="item['fieldf' + (index + 1) + 7].defaultIndex"
                    @confirm="onConfirm"
                    @cancel="item['fieldf' + (index + 1) + 7].showPicker = false"
                />
            </hua-popup> -->
            <!-- 银行卡号 -->
            <!-- <hua-field
                :key="'fieldf' + (index + 1) + 8"
                clearable
                readonly
                v-if="timeType === '2'"
                :type="item['fieldf' + (index + 1) + 8].type"
                :label="item['fieldf' + (index + 1) + 8].label"
                :required="item['fieldf' + (index + 1) + 8].require"
                :maxLength="item['fieldf' + (index + 1) + 8].maxLength"
                :rules="item['fieldf' + (index + 1) + 8].rules"
                v-model="item['fieldf' + (index + 1) + 8].value"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 8].placeholder"
            /> -->
            <!-- 开户行姓名 -->
            <!-- <hua-field
                clearable
                readonly
                :key="'fieldf' + (index + 1) + 9"
                v-if="timeType === '2'"
                :type="item['fieldf' + (index + 1) + 9].type"
                :label="item['fieldf' + (index + 1) + 9].label"
                :required="item['fieldf' + (index + 1) + 9].require"
                :maxLength="item['fieldf' + (index + 1) + 9].maxLength"
                :rules="item['fieldf' + (index + 1) + 9].rules"
                v-model="item['fieldf' + (index + 1) + 9].value"
                :placeholder="!!id ? ' ' : item['fieldf' + (index + 1) + 9].placeholder"
            /> -->
            </div>
          </template>
        </div>






        <!-- 指定下一级审批人员 -->
        <div class="form-block">
        <hua-field
            key="field37"
            :right-icon="isNoBtn ? '' : 'arrow'"
            readonly
            :type="formFields['field37'].type"
            :label="formFields['field37'].label"
            :required="formFields['field37'].require"
            :rules="formFields['field37'].rules"
            v-model="formFields['field37'].value"
            :placeholder="formFields['field37'].placeholder"
            @click="formFields['field37'].showPicker = true"
        />
        <hua-popup  v-model="formFields['field37'].showPicker" position="bottom" round @close="closeNextPersonPopup">
          <div class="customContent">
            <div class="area-content-title">
              <div @click="closeNextPersonPopup">取消</div>
              <div>指定下一级审批人员</div>
              <div @click="personChange">确定</div>
            </div>
            <hua-radio-group v-model="personIdListTemp">
              <hua-cell-group>
                <hua-cell
                    clickable
                    v-for="item in formFields['field37'].personList"
                    :key="item.value"
                    :title="item.text"
                >
                  <template #right-icon>
                    <!-- <hua-checkbox ref="checkboxes" :name="item.value"/> -->
                    <!-- van-radio -->
                    <hua-radio ref="checkboxes" :name="item.value"/>
                  </template>
                </hua-cell>
              </hua-cell-group>
            </hua-radio-group>
          </div>
        </hua-popup>
        <hua-field
            class="visit-reason"
            clearable
            :type="formFields['field33'].type"
            :label="formFields['field33'].label"
            :required="formFields['field33'].require"
            :maxLength="formFields['field33'].maxLength"
            :rules="formFields['field33'].rules"
            v-model="formFields['field33'].value"
            :placeholder="!!id ? ' ' : formFields['field33'].placeholder"
        />
        </div>




        <!-- 民族 -->
        <!-- <hua-field
            key="field34"
            readonly
            clickable
            name="picker"
            v-if="timeType === '2'"
            :right-icon="!!id ? '' : 'arrow'"
            :label="formFields['field34'].label"
            :required="formFields['field34'].require"
            :rules="formFields['field34'].rules"
            :value="formFields['field34'].text"
            :placeholder="formFields['field34'].placeholder"
            @click-right-icon="formFields['field34'].showPicker = true"
        >
        </hua-field>
        <hua-popup v-model="formFields['field34'].showPicker" round position="bottom">
          <hua-picker
              key="field12"
              show-toolbar
              :columns="formFields['field34'].columns"
              :default-index="formFields['field34'].defaultIndex"
              @confirm="formFields['field34'].confirm"
              @cancel="formFields['field34'].showPicker = false"
          />
        </hua-popup> -->
        <!-- 银行卡号 -->
        <!-- <hua-field
            clearable
            v-if="timeType === '2'"
            :type="formFields['field35'].type"
            :label="formFields['field35'].label"
            :required="formFields['field35'].require"
            :maxLength="formFields['field35'].maxLength"
            :rules="formFields['field35'].rules"
            v-model="formFields['field35'].value"
            :placeholder="!!id ? ' ' : formFields['field35'].placeholder"
        /> -->
         <!-- 开户行姓名 -->
        <!-- <hua-field
            clearable
            v-if="timeType === '2'"
            :type="formFields['field36'].type"
            :label="formFields['field36'].label"
            :required="formFields['field36'].require"
            :maxLength="formFields['field36'].maxLength"
            :rules="formFields['field36'].rules"
            v-model="formFields['field36'].value"
            :placeholder="!!id ? ' ' : formFields['field36'].placeholder"
        /> -->



        <!-- 邀约  存在登录人员的v_personid,不存在数据id-->
        <div v-if="v_personid && !id" style="margin: 16px">
          <hua-button
              round
              block
              type="primary"
              native-type="submit"
              :disabled="isDisabled"
          >提交
          </hua-button
          >
        </div>
        <!-- 待审核  存在数据id且登录的用户是可以审核的-->
        <div v-else-if="id && operate === 'audit' && reviewable" class="btn-box">
          <hua-button class="pass-fail" round type="default" @click.prevent="notAllow"
          >不通过
          </hua-button
          >
          <hua-button class="submit" round type="primary" @click.prevent="utils.debounce(allow, 1000)"
          >通过
          </hua-button
          >
        </div>
        <!-- 预约成功等  相当于只能查看预约成功的、失败的、已离访的，审核不通过的、登录的用户不能审核的-->
        <div v-else-if="isNoBtn"></div>
        <!-- 预约 -->
        <div v-else :class="isEpidemicInfoRequired ? 'btn-box' : 'btn-box-no'">
          <hua-button
              v-if="isEpidemicInfoRequired"
              class="prevstep"
              round
              type="default"
              style="bordercolor: #0a86ff"
              @click.prevent="changeSteps"
          >上一步
          </hua-button
          >
          <hua-button
              :class="isEpidemicInfoRequired ? 'submit' : ''"
              round
              type="primary"
              native-type="submit"
          >提交
          </hua-button
          >
        </div>
      </hua-form>
      <!-- 访问类型弹框 -->
      <hua-popup v-model="formFields['field3'].showPicker" round position="bottom">
        <hua-picker
            key="field6"
            show-toolbar
            :columns="formFields['field3'].columns"
            :default-index="formFields['field3'].defaultIndex"
            @confirm="formFields['field3'].confirm"
            @cancel="formFields['field3'].showPicker = false"
        />
      </hua-popup>

      <hua-dialog
          v-model="show"
          :title="'防疫信息确认'"
          :lazy-render="false"
          :showCancelButton="true"
          confirmButtonText="确认通过"
          confirm-button-color="#007aff"
          cancel-button-color="#1a1a1a"
          :overlay="true"
          @confirm="onReviewConfirm"
          @cancel="onReviewCancel"
          @click.prevent="() => {}"
      >
        <div class="customContent">
          <hua-image-preview
              :showIndicators="true"
              :showIndex="false"
              :overlay="false"
              v-model="show"
              :images="images"
              index-center="center"
              :get-container="() => getContainer1('hua-dialog__content')"
              @change="onChange"
          >
            <template #index>{{ index + 1 }}</template>
          </hua-image-preview>
        </div>
      </hua-dialog>
    </div>
    <hua-popup v-model="cropperModal" position="bottom" :style="{ height: '100%', width: '100%' }">
        <div class="header-wrapper" style="height: 5%; display: flex; align-items: center; text-align: center">
            <span class="header-text" @click="cropperModal = false">取消</span>
            <span class="header-text" @click="rotateLeft">左旋转</span>
            <span class="header-text" @click="rotateRight">右旋转</span>
            <span class="header-text" @click="handleCropperPhoto">裁剪</span>
        </div>
        <div class="cropper-box" style="background: black; height: 95%; width: 100%; min-width: 100%; overflow: hidden">
            <VueCropper
                ref="cropper"
                :style="{background: 'black', marginBottom:'15%'}"
                :img="cropperBase64"
                :autoCrop="true"
                :centerBox="true"
                :full="true"
                :canScale="true"
                :canMove="true"
                :canMoveBox="true"
            ></VueCropper>
        </div>
        <div class="cropper-bg"></div>
    </hua-popup>
  </div>
</template>
<script>
import api from '@/constants/api'
import lrz from 'lrz'
import utils from '@/constants/utils'
import eventBus from '@/constants/eventBus.js'
import rexp from '@/constants/rexp'
// import ImageCompressor from '@/tools/imageCompressor'
import moment from 'moment'
import { Toast } from 'vant';
import {aes_decrypt, getKey} from '@/tools/myEncrypt'
import image from '@/image/head.jpg'
export default {
  name: 'reserve',
  components: {
  },
  props: {
    // 访问模式1学生2教职工
    visitorMode: {
      type: [String, Number],
      default: ''
    },
    // 查看详情时有 isv_id,id,operate,v_timeStr,v_healthCodePic,v_personid
    // 邀约有v_personid,u_phone,u_name
    v_personid: {
      type: String,
    },
    isv_id: {
      type: String,
    },
    id: {
      type: String | Number,
    },
    operate: {
      type: String,
    },
    v_timeStr: {
      type: String,
    },
    v_healthCodePic: {
      type: String,
    },
    steps: {
      type: Number,
    },
    u_name: {
      type: String,
    },
    u_phone: {
      type: String,
    },
    isOrder: {
      type: Boolean,
      default: true
    },
    openId: {
      type: String,
      default: null
    }
  },
  created() {
    this.picArr = []
    eventBus.$on('add', (message) => {
      this.picArr = message
      //一些操作，message就是从兄弟组件传过来的值
    })

    this.getBaseConfig()
    this.getVistorArea()
    api.getVisitConfig(152).then(res => {
      let str1 = ''
      str1 = res.data[0].value.split('###')[0]
      this.longconfigtime1 = str1.replace('-', '/')
      let str2 = ''
      str2 = res.data[0].value.split('###')[1]
      this.longconfigtime2 = str2.replace('-', '/')
    })
  },

  mounted() {
    // 默认展示访问类型为“短期访问”的访客类型
    this.getVisitorType('1');
    // this.getAllNation();
    this.followVisitors = []

    console.log(this.id);
    this.$nextTick(() => {
      if(this.visitorMode == 1) {
        this.formFields['field9'].value = 1;
        this.followFormList = [];
        this.followVisitors = [];
      }
      if(!this.$route.params.showOrg) {
        this.getTab()
      }
      if (this.v_personid && !this.id) {
        this.formFields['field1'].value = this.u_phone || localStorage.getItem('u_phone')
        this.formFields['field2'].text =
            this.u_name || sessionStorage.getItem('u_name')
        //  this.formFields['field1'].value = this.u_phone
        // this.formFields['field2'].text = this.u_name
        this.formFields['field29'].value = sessionStorage.getItem('u_jobNumber')
        this.formFields['field30'].text = this.u_name || sessionStorage.getItem('u_name')
        this.formFields['departmentId'].text = localStorage.getItem('u_deptName') ? localStorage.getItem('u_deptName') : ''
        this.formFields['field28'].text = this.u_name || sessionStorage.getItem('u_name')
      } else if (this.id) {
        this.getVisitorInfoById()
      }
      if(this.$route.params.isv_phone) {
        this.formFields['field1'].value = this.$route.params.isv_phone
        this.formFields['field2'].text = this.$route.params.isv_name
        this.formFields['field2'].value = this.$route.params.isv_id
        this.isvId = this.$route.params.isv_id
        this.formFields['field4'].value = this.$route.params.v_timeStr.slice(-3, 0)
        this.formFields['field5'].value = this.$route.params.v_lvTimeStr.slice(-3, 0)
        this.formFields['field12'].value = this.$route.params.v_phone
        this.formFields['field9'].value = this.$route.params.v_personSum
        this.visitorNum111(this.$route.params.v_personSum)
        this.formFields['field28'].text = this.$route.params.isv_name
        this.formFields['departmentId'].text = this.$route.params.isv_dept_name
        this.isEdit = true
      }
      console.log(this.$route.params);
      // if (this.$route.params.id) {
      //   this.getNextPerson(this.$route.params.id)
      // }

    })
  },

  data() {
    return {
      visitorAreaOptions: [],
        customMzCode:"",  //民族代码
        zoomD: 1,
        faceFile: {},
        cropperBase64: '', //图片裁剪Url
        cropperModal: false,//图片裁剪弹框
        curFormPhotoName: '',//当前裁剪的字段名
      treeDataObject: {},
      treeDataList: [],
      isEdit: false,
      usePhoto: false,
      tempPhone: '',
      utils,
      isNoBtn: false,
      isDisabled: false,
      reviewable: null,
      images: [],
      isEpidemicInfoRequired: false,
      show: false,
      picArr: [],
      isvId: null,
      showTab: null,
      isIntervieweeRequired: true,
      isFollowerRequired: true,
      isApprovingRequired: false,
      visitorArea: '',
      approvingFormList: [],
      //rexp setting
      rexp,
      areaIdListTemp: [], // 所选访问区域
      personIdListTemp: '', // 所选下一级审核人员
      //btndisabled
      searchDisabled: true,
      //图片上传
      fileList: [],
      //访问次数限制
      visitNum: 10000,
      visitorNum: 10000,
      uploadPhoto: false,
      //tabs
      showPopover: false,
      actions: [{text: '临时访问不支持跨天；长期访问支持跨天，不限制天数'}],
      tabActive: '1',
      tabsList: [
        {
          label: '被访人员信息',
          value: '1',
        },
        {
          label: '来访信息',
          value: '2',
        },
        {
          label: '访客信息',
          value: '3',
        },
        {
          label: '审批信息',
          value: '4',
        },
      ],
      show: false,
      indexList: [1, 2, 3],
      //主访人信息
      formFields: {
        departmentId: {
          label: '所属部门',
          placeholder: '请选择所属部门',
          value: '',
          text: '',
          code: '',
          required: true,
          rules: [
            {
              required: true,
              message: '请选择所属组织',
            },
          ],
          showPicker: false
        },
        field28: {
          paramName: 'personName',
          text: '',
          value: '',
          label: '拜访人员',
          placeholder: '请选择',
          defaultIndex: 0,
          require: true,
          readonly: true,
          showPicker: false,
          columns: [],
          rules: [
            {
              required: true,
              message: '请选择拜访人员',
            },
          ],
          confirm: this.onConfirm,
        },
        field1: {
          paramName: 'isv_phone',
          type: 'tel',
          value: '',
          placeholder: '请输入',
          rules: [
            {
              validator: this.isv_phoneValidate,
              message: (value) => {
                if (value) {
                  return '手机号码格式不正确'
                } else {
                  return '请输入手机号码'
                }
              },
            },
          ],
          maxLength: 11,
          change: this.phoneNumChange,
          search: this.phoneNumSearch,
        },
        field2: {
          paramName: 'isv_id',
          type: 'text',
          text: '',
          value: '',
          label: '拜访人员',
          placeholder: '根据手机号码自动获取',
          readonly: true,
        },
        field3: {
          paramName: 'timeType',
          text: '临时访问',
          value: '1',
          label: '访问类型',
          showPicker: false,
          defaultIndex: 0,
          columns: [
            {
              id: 'field3',
              text: '临时访问',
              value: '1',
            },
            {
              id: 'field3',
              text: '长期访问',
              value: '2',
            },
          ],
          rules: [
            {
              required: true,
              message: '请选择访问类型',
            },
          ],
          confirm: this.onConfirm,
        },
        field4: {
          paramName: 'v_timeStr',
          value: '',
          label: '来访时间',
          placeholder: '请选择',
          require: true,
          readonly: true,
          showPicker: false,
          //new Date(2020, 0, 1),
          minDate: new Date(),
          //new Date(2030, 12, 31),
          maxDate: new Date((new Date() / 1000 + 86400 * 3650) * 1000),
          currentDate: new Date(new Date().getTime() + (5 * 60 * 1000) - 1),
          rules: [
            {
              required: true,
              message: '请选择来访时间',
            },
          ],
        },
        field5: {
          paramName: 'v_lvTimeStr',
          value: '',
          label: '离访时间',
          placeholder: '请选择',
          require: true,
          readonly: true,
          showPicker: false,
          minDate: new Date(), //new Date(2020, 0, 1),
          maxDate: new Date((new Date() / 1000 + 86400 * 3650) * 1000), //new Date(2030, 12, 31),
          currentDate: new Date(new Date(new Date().toLocaleDateString()).getTime() + (22 * 60 * 60 * 1000)),
          rules: [
            {
              required: true,
              message: '请选择离访时间',
            },
          ],
        },
        field6: {
          paramName: 'secondVisitorType',
          text: '',
          value: '',
          label: '访客类型',
          placeholder: '请选择',
          defaultIndex: 0,
          require: true,
          readonly: true,
          showPicker: false,
          columns: [],
          rules: [
            {
              required: true,
              message: '请选择访客类型',
            },
          ],
          confirm: this.onConfirm,
        },
        field7: {
          paramName: 'times',
          type: 'digit',
          value: 9999,
          label: '访问次数',
          placeholder: '请输入1-200正整数',
          require: true,
          extra: '次',
          rules: [
            {
              required: true,
              message: '请输入访问次数',
            },
            {
              pattern: /^([1-9]|[1-9]\d|1\d{2}|200)$/,
              message: '访问次数只能输入1-200之间的正整数',
            },
          ],
        },
        field8: {
          paramName: 'v_reason',
          type: 'textarea',
          value: '',
          label: '来访事由',
          placeholder: '请输入',
          require: false,
          maxLength: 200,
          rules: [],
        },
        field9: {
          paramName: 'v_personSum',
          type: 'digit',
          value: '',
          label: '来访人数',
          placeholder: '请输入1-20正整数',
          require: true,
          rules: [
            {
              pattern: /^([1-9]|1\d{1}|20)$/,
              message: (value) => {
                if (value) {
                  return '来访人数支持1-20的正整数'
                } else {
                  return '请输入来访人数'
                }
              },
            },
          ],
        },
        field10: {
          paramName: 'v_name',
          type: 'text',
          value: '',
          label: '访客姓名',
          placeholder: '请输入',
          maxLength: 20,
          require: true,
          isInner: null,
          rules: [
            // {
            // //   pattern: rexp.treeNameRexp,
            //   require: true,
            //   message: (value) => {
            //     if (value) {
            //       return '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格'
            //     } else {
            //       return '请输入访客姓名'
            //     }
            //   },
            // },
            {
              required: true,
              message: '请输入访客姓名',
            },
            {
              validator: this.validatorNameSpace,
              message: '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格',
            },
            {
              pattern: /^[a-zA-Z0-9_@.·\-\s\u4E00-\u9FA5\u3400-\u4DBF]{0,25}$/,
              message: '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格',
            },
          ],
        },
        field11: {
          paramName: 'faceFile',
          type: 'text',
          value: '',
          label: '人脸照片',
          require: false,
          maxSize: 1024 * 1024 * 4 + '',
          fileList: [],
          rules: [
            {
            //   validator: this.validatorImgA,
            //   message: '请选择人脸照片',
            },
          ],
        },
        field12: {
          paramName: 'v_phone',
          type: 'tel',
          value: '',
          label: '联系电话',
          maxLength: 11,
          placeholder: '请输入',
          require: true,
          rules: [
            {
              pattern: rexp.phone,
              message: (value) => {
                if (value) {
                  return '手机号码格式不正确'
                } else {
                  return '请输入手机号码'
                }
              },
            },
          ],
        },
        field13: {
          paramName: 'v_certificateType',
          value: '身份证',
          label: '证件类型',
          placeholder: '请选择',
          require: true,
          readonly: true,
          showPicker: false,
          columns: [
            {
              id: 'field13',
              text: '身份证',
              value: '身份证',
            },
            {id: 'field13', text: '军官证', value: '军官证'},
            {id: 'field13', text: '学生证', value: '学生证'},
            {id: 'field13', text: '驾驶证', value: '驾驶证'},
            {id: 'field13', text: '护照', value: '护照'},
            {id: 'field13', text: '港澳通行证', value: '港澳通行证'},
          ],
          confirm: this.onConfirm,
        },
        field14: {
          paramName: 'v_certificateNumber',
          type: 'text',
          value: '',
          label: '证件号码',
          placeholder: '请输入',
          require: true,
          maxLength: 25,
          rules: [{
                required: true,
                message: '请输入证件号码',
            },
            {
                cardTypefield: 'field13',
                validator: this.validatorIdCard,
                message: '证件号码格式有误',
            },
          ],
        },
        field15: {
          paramName: 'v_dw',
          type: 'text',
          value: '',
          label: '来访单位',
          placeholder: '请输入',
          require: false,
          maxLength: 20,
          rules: [
            {
              pattern: rexp.treeName,
              message: '请输入合法字符',
            },
          ],
        },
        field16: {
          paramName: 'v_address',
          type: 'text',
          value: '',
          label: '访客住址',
          placeholder: '请输入',
          require: false,
          maxLength: 20,
          rules: [
            {
              pattern: rexp.treeName,
              message: '请输入合法字符',
            },
          ],
        },
        field17: {
          paramName: 'v_plateNumber',
          value: '',
          label: '车牌号码',
          placeholder: '请按车牌号标准格式填写,如:新A12345',
          require: false,
          maxLength: 8,
          rules: [
            {
              validator: this.validatorCardIdSpace,
              message: '车牌号存在空格，请重新输入',
            },
            {
              validator: this.validatorCardId, // /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/, //加入新能源车牌
              message: '请输入正确车牌号码',
            },
          ],
        },
        field18: {
          paramName: 'areaIdList',
          type: 'text',
          value: '',
          label: '访问区域',
          placeholder: '请选择',
          require: true,
          showPicker: false,
          areaNameList: [],
          areaList: [],
          areaIdList: [],
          rules: [
            {
              validator: this.areaVlidator,
              message: '请选择访问区域',
            },
          ],
        },
        field24: {
          paramName: 'chargeOrNot',
          text: '',
          value: '',
          label: '是否收费',
          placeholder: '请选择',
          defaultIndex: 0,
          require: true,
          readonly: true,
          showPicker: false,
          columns: [
            {
              id: 'field24',
              text: '是',
              value: 1,
            },
            {
              id: 'field24',
              text: '否',
              value: 0,
            },
          ],
          rules: [
            {
              required: true,
              message: '请选择是否收费',
            },
          ],
          confirm: this.onConfirm,
        },
        field26: {
          paramName: 'freeParkingTimes',
          text: '',
          value: '',
          label: '收费时长',
          placeholder: '请选择',
          defaultIndex: 0,
          require: true,
          readonly: true,
          showPicker: false,
          columns: (() => {
            let result = []
            for(let index = 1; index < 25; index++) {
              result.push({
                id: 'field26',
                text: index +'小时',
                value: index
              })
            }
            return result
          })(),
          rules: [
            {
              required: true,
              message: '请选择收费时长',
            },
          ],
          confirm: this.onConfirm,
        },
        field37: {
          paramName: 'nextPersonList',
          type: 'text',
          value: '',
          label: '指定下一级审批人员',
          placeholder: '请选择',
          require: true,
          showPicker: false,
          personNameList: [],
          personList: [],
          chooseIdList: [],
          rules: [
            {
              validator: this.personVlidator,
              message: '请选择下一级审批人',
            },
          ],
        },
        field33: {
          paramName: 'approvalOpinion',
          value: '',
          label: '审核意见',
          placeholder: '请输入',
          require: false,
          maxLength: 15,
          type: 'textarea'
        },
        field34: {
          paramName: 'customMzName',
          text: '',
          value: '',
          label: '民族',
          placeholder: '请选择',
          defaultIndex: 0,
          require: true,
          readonly: true,
          showPicker: false,
          columns: [],
          code:"",
          rules: [
            {
                required: true,
                message: '请选择民族',
            },
          ],
          confirm: this.onConfirm,
        },
        field35: {
          paramName: 'customBankCardNumber',
          value: '',
          label: '银行卡号',
          placeholder: '请输入',
          require: true,
        //   maxLength: 15,
          type: 'text',
          rules: [
            {
                required: true,
                message: '请输入银行卡号',
            },
          ],
        },
        field36: {
          paramName: 'customBankName',
          value: '',
          label: '开户行名称',
          placeholder: '请输入',
          require: true,
        //   maxLength: 15,
          type: 'text',
          rules: [
            {
                required: true,
                message: '请输入开户行名称',
            },
          ],
        },
        field29: {
        //   paramName: 'isv_phone',
          type: 'tel',
          value: '',
          placeholder: '请输入',
          rules: [
            {
              required:true,
              message: (value) => {
                if (!value) {
                  return '请输入工号'
                }
              },
            },
          ],
        //   maxLength: 11,
          change: this.jobNumberChange,
          search: this.jobNumberSearch,
        },
        field30: {
          paramName: 'isv_id',
          type: 'text',
          text: '',
          value: '',
          label: '拜访人员',
          rules: [
            {
              required:true,
              message: (value) => {
                if (!value) {
                  return '请根据工号获取拜访人员'
                }
              },
            },
          ],
          placeholder: '根据工号自动获取',
          readonly: true,
        },
      },
      followFormList: [],
      followVisitors: [],
      appointmentCode: '',
      qrcode: null,
      v_barCode: '',
      status: '',
      index: 0,
      appointTime: '',
      obj: null,
      visitorTypeList: [],
      nationInfoList: [],
      showPlateNumber:true,  // 是否展示车牌号码
      leaveTime:"",
      timeType:"1",
      shortTermSwitch: false,
      longTermSwitch: false,
      imageRules:[],
      imageTipContent:"",
      imageYesOrNo:false,  // 人脸照片是否必传
      longconfigtime1: '',
      longconfigtime2: '',
      defaultImage: image,
    }
  },
  watch: {
    'formFields.field6.value': function (newValue, oldValue) {
        api.getCarAuthority(newValue).then(res => {
            if(res.success) {
                this.showPlateNumber = res.data === 1 ? true :false
            }
        })
    },
    // id: {
    //     handler(newVal) {
    //         this.getNextPerson(newVal);
    //     }
    // }
    'personIdListTemp': (newVal) => {
      console.log(newVal)

    },
    visitorMode: {
      handler() {
        if(this.visitorMode == 1) {
          this.formFields['field9'].value = 1;
          this.followFormList = [];
          this.followVisitors = [];
        }
      }
    }
  },
  methods: {
      /**
         * @function 点击裁切
         */
        cropSucess({ image }) {
            this.showPop = false;
            this.isShowCover = false
            this.photoBase64 = image;
        },

    //坐旋转
    rotateLeft() {
        this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
        this.$refs.cropper.rotateRight();
    },
    // 获取 base64 截图数据并放置到 Avatar 组件
    handleCropperPhoto () {

        this.$refs.cropper.getCropData(data => {
            if (this.curFormPhotoName.includes('fieldf')) {
                let index = Number(this.curFormPhotoName.substring(6, this.curFormPhotoName.length - 1)) - 1
                this.followFormList[index][this.curFormPhotoName].fileList = [{url: data, isImage: true}];
            }else{
                this.formFields[this.curFormPhotoName].fileList = [{url: data, isImage: true}] //如果图片URL中不包含类型信息，可以添加 isImage 标记来声明
            }
            let faceFile = this.base64ToFile(data)
            let fileObj = {file: faceFile}
            this.cropperModal = false
            this.handleChange(fileObj, this.curFormPhotoName)
        })
    },
    // base64转文件
    base64ToFile(dataurl, fileName = "file") {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        // suffix是该文件的后缀
        let suffix = mime.split('/')[1];
        // atob 对经过 base-64 编码的字符串进行解码
        let bstr = atob(arr[1]);
        // n 是解码后的长度
        let n = bstr.length;
        // Uint8Array 数组类型表示一个 8 位无符号整型数组 初始值都是 数子0
        let u8arr = new Uint8Array(n);
        // charCodeAt() 方法可返回指定位置的字符的 Unicode 编码。这个返回值是 0 - 65535 之间的整数
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        // new File返回File对象 第一个参数是 ArraryBuffer 或 Bolb 或Arrary 第二个参数是文件名
        // 第三个参数是 要放到文件中的内容的 MIME 类型
        return new File([u8arr], `${fileName}.${suffix}`, {
            type: mime,
        });
    },
    //  文件上传  return false 阻止 Upload 组件自动上传并将 file 对象转成 base64 赋值给截图源
    uploadIntercept(file, str) {
        this.curFormPhotoName = str
        let _this = this
        lrz(file, {quality: 0.6}).then(function (rst) {
            // 处理成功会执行
            // console.log(rst);
            console.log("人脸图片压缩后大小：" + rst.fileLen / 1024, rst, file);
            _this.cropperBase64 = rst.base64
            _this.cropperModal = true
        })
        .catch(function (err) {
            // 处理失败会执行
            console.log(err);
        })
        .always(function () {
            // 不管是成功失败，都会执行
        });
        return false
    },
    changeSteps() {
      this.$emit('stepsChange', 0)
    },

    // 用户信息回显父组件切换tab至邀约页面时调用
    echoUser() {
        console.log(this.u_phone || localStorage.getItem('u_phone'), 'this.u_phone----------')
      this.formFields['field1'].value = this.u_phone || localStorage.getItem('u_phone')
      this.formFields['field2'].text =
          this.u_name || sessionStorage.getItem('u_name')
    },

    // 获取基础配置信息
    getBaseConfig() {
      api.getBaseConfig().then((res) => {
        this.isIntervieweeRequired =
            res.data['visitor.interviewee.required'] === '0' ? false : true
        this.isFollowerRequired =
            res.data['followed.visitor.required'] === '0' ? false : true
        this.isEpidemicInfoRequired = !!res.data['visitor.epidemic.enable']
      })
    },

    // 获取短期访客图片配置
    async visitShortConfig() {
        try {
            let res = await api.getVisitConfig(138);
            if(res.success) {
                if (res.data[0].value === '1') {
                    this.shortTermSwitch = true
                    this.formFields['field11'].require = true
                    this.imageRules = this.formFields['field11'].rules = [
                        {
                            required: true,
                            message: '请上传人脸照片',
                        },
                    ]
                    this.imageYesOrNo = true
                } else if(res.data[0].value === '0') {
                    this.shortTermSwitch = false
                    this.formFields['field11'].require = false
                    this.formFields['field11'].rules = []
                    this.imageYesOrNo = false
                }
            }
        } catch (error) {
            console.log(error)
        }
    },

    // 获取长期访客图片配置
    async visitLongConfig() {
        try {
            let res = await api.getVisitConfig(139);
            if(res.success) {
                if (res.data[0].value === '1') {
                    this.longTermSwitch = true
                    this.formFields['field11'].require = true
                    this.imageRules = this.formFields['field11'].rules = [
                        {
                            required: true,
                            message: '请选择人脸照片',
                        },
                    ]
                    this.imageYesOrNo = true
                } else if(res.data[0].value === '0') {
                    this.longTermSwitch = false
                    this.formFields['field11'].require = false
                    this.formFields['field11'].rules = []
                    this.imageYesOrNo = false
                }
            }
        } catch (error) {
            console.log(error)
        }
    },

    // 获取长期访客图片配置
    async getImageTip() {
        try {
            let res = await api.getVisitConfig(140);
            if(res.success) {
                this.imageTipContent = res.data[0].value
                if (this.imageTipContent.length > 25) {
                    this.imageTipContent = this.imageTipContent.slice(0,25) + '...'
                }
            }
        } catch (error) {
            console.log(error)
        }
    },

    // 访客类型
    getVisitorType(type) {
      this.visitorTypeList = []
      let that = this
      api.getVisitorType(type, this.visitorMode || '')
      .then((res) => {
        console.log('访客类型输出===', res);

        that.visitorTypeList = res.data.map((item, i) => {
          return {text: item.typeName, value: item.id, id: 'field6', index: i}
        })
        // console.log(res, that.visitorTypeList, '78798');
        that.formFields['field6'].columns = that.visitorTypeList
        that.formFields['field6'].value = that.visitorTypeList[0].value
        that.formFields['field6'].text = that.visitorTypeList[0].text
        let arr = []
        arr = this.visitorTypeList.filter(item => {
          return item.value == that.visitorTypeList[0].value
        })
        let param = {
            pageSize: 100, //每页展示的条数
            pageNum: 1, //第几个页码
            searchKey: arr[0].text,
        };
        this.formFields['field18'].areaList = []
        api.getVistorAreaByVisitor(param).then(res => {
          res.data.pageData && res.data.pageData[0].areaIdList && res.data.pageData[0].areaIdList.forEach(item => {
            this.visitorAreaOptions.forEach(ele => {
                if (item == ele.value) {
                  this.formFields['field18'].areaList.push(ele)
                }
            })
          })
        })
        this.getNextPerson(that.visitorTypeList[0].value)
      })
      .catch((err) => {
        console.log(err)
      })
      if (type == '1') {
        this.visitShortConfig()
      } else if(type == '2') {
        this.visitLongConfig()
      }
        this.getImageTip()
    },

    // 获取所有民族信息
    getAllNation() {
        this.nationInfoList = []
        let that = this;
        let params = {
            pageNum: 1,
            pageSize: 100,
            userId: localStorage.getItem('v_personid') ? JSON.parse(localStorage.getItem('v_personid')) : ''
        }
        try {
            api.getNationInfo(params).then(res => {
                if (res.success) {
                    that.nationInfoList = res.data.value.map((item, i) => {
                        return {text: item.name, value: item.code, id: 'field34', index: i}
                    })
                    that.formFields['field34'].columns = that.nationInfoList
                    // that.formFields['field34'].value = that.nationInfoList[0].value
                    // that.formFields['field34'].text = that.nationInfoList[0].text
                }
            }).catch(err => {
                console.log(err,"err=========")
            })
        } catch (error) {
            console.log(error)
        }
    },

    // 访客区域
    getVistorArea() {
      let param = {
        pageNum: 1,
        pageSize: 1000,
        areaName: '',
      }
      this.visitorAreaOptions = []
      api.getVistorArea(param).then((res) => {
        let data = res.data.pageData
        data.map((item) => {
          // this.formFields['field18'].areaList.push({
          //   text: item.areaName,
          //   value: item.id,
          // })
          this.visitorAreaOptions.push({
            text: item.areaName,
            value: item.id,
          })
        })
      })
    },
    // 下一级审批人员
    getNextPerson(value) {
      let param = {
          "isv_id": this.$route.params.id,
          "secondVisitorType": value,
          visitorMode: this.visitorMode || ''
      }
      api.getNextPerson1(param).then((res) => {
        if(res.success) {
          if(res.data && res.data.length) {
            this.formFields['field37'].personList = res.data.map(item => {
                return {
                    text: item.reviewUserName,
                    value: item.reviewUserId
                }
            })
          } else {
            this.formFields['field37'].personList = []
          }
        }
      })
    },

    // 预约详情
    getVisitorInfoById() {
      let params = {
        id: this.id,
        isv_id: this.v_personid,
        v_timeStr: this.v_timeStr,
      }
      api.getVisitorInfoById(params)
      .then((res) => {
        let data = res.data
        this.reviewable = data.reviewable
        // 查看详情与不能审核时没有底部按钮所有字段不可编辑
        this.isNoBtn =
            (this.id && this.operate === 'detail') ||
            (this.id && this.operate === 'audit' && !this.reviewable)
                ? true
                : false
        this.appointTime = data.v_timeStr
        this.formFields['field1'].value = data.isv_phone
        this.formFields['field2'].text = data.isv_name === '--' ? '' : data.isv_name
        this.formFields['field3'].text =
            data.timeType === 1 ? '临时访问' : '长期访问'
        this.formFields['field3'].defaultIndex = data.timeType === 1 ? 0 : 1
        this.formFields['field4'].value = data.v_timeStr
        this.formFields['field5'].value = data.v_lvTimeStr
        this.formFields['field6'].text = data.secondVisitorTypeName
        this.visitorTypeList.map((item) => {
          if (item.value === data.secondVisitorType) {
            this.formFields['field6'].defaultIndex = item.index
          }
        })[0]
        this.formFields['field24'].value = data.chargeOrNot
        this.formFields['field24'].text = data.chargeOrNot === 0 ? '否' : data.chargeOrNot === 1 ? '是' : ''
        this.formFields['field26'].value = data.freeParkingTimes ? data.freeParkingTimes / 60 : ''
        this.formFields['field26'].text = this.formFields['field26'].value ? this.formFields['field26'].value + '小时' : ''
        // console.log(this.formFields['field24'], this.formFields['field26'])
        this.formFields['field7'].value = data.times
        this.formFields['field8'].value = data.v_reason
        this.formFields['field18'].value = data.areaListName
        this.formFields['field18'].areaIdList = this.areaIdListTemp = data.areaIdList
        this.formFields['field9'].value = data.v_personSum
        this.formFields['field10'].value = data.v_name
        this.formFields['field12'].value = data.v_phone
        this.formFields['field13'].value = data.v_certificateType
        this.formFields['field14'].value = data.v_certificateNumber
        this.formFields['field15'].value = data.v_dw
        this.formFields['field16'].value = data.v_address
        this.formFields['field17'].value = data.v_plateNumber
        this.formFields['field11'].fileList = data.v_capturePic
            ? [{url: this.getImageUrl(data.v_capturePic, data.id)}]
            : []
        this.images = []
        let v_healthCodePic = this.getImageUrl(data.v_healthCodePic)
        let v_travelCodePic = this.getImageUrl(data.v_travelCodePic)
        if (v_healthCodePic) {
          this.images.push(v_healthCodePic)
        }
        if (v_travelCodePic) {
          this.images.push(v_travelCodePic)
        }
        this.followVisitors = data.followVisitors
        this.visitorNumBlur(data.v_personSum)
        this.status = data.status
        // 4 审核不通过，状态是预约取消，不展示二维码
        if (this.status === 4) {
          return false
        }
        this.appointmentCode = data.appointmentCode
        this.v_barCode = data.v_barCode
        // 待审核状态也不展示二维码
        if (this.operate !== 'audit') {
          this.getPersonQRCode(this.v_barCode)
        }
      })
      .catch((err) => {
        console.log(err, 'err')
      })
      if(this.operate != 'audit') {
          let param = {
            visitorId: this.id
          }
          api.getVisitorInfo(param).then(res => {
            this.formFields['field33'].value = res.data[0].approvalOpinion
            // console.log(res, '789456');
            if(res.data.length > 0) {
              this.isApprovingRequired = true
              this.numberOfApproving(res.data)
            }
          })
      }

    },
    numberOfApproving(e) {
      this.approvingFormList = []
      let num = e.length
      if (num) {
        for (let i = 0; i < num ; i++) {
          let id = i + 1
          let targetObj = {}
          targetObj['fieldf' + id + 1] = {
            type: 'text',
            value: e[i].realReviewUserName,
            label: '实际审批人',
          }
          targetObj['fieldf' + id + 2] = {
            type: 'text',
            value: e[i].reviewLevelName,
            label: '审核级别',
          }
          targetObj['fieldf' + id + 3] = {
            type: 'text',
            value:  e[i].reviewUserName,
            label: '审批人',
          }
          targetObj['fieldf' + id + 4] = {
            type: 'text',
            value: e[i].reviewTime,
            label: '审批时间',
          }
          targetObj['fieldf' + id + 5] = {
            type: 'text',
            value: e[i].reviewStateName,
            label: '审批状态',
          }
          targetObj['fieldf' + id + 6] = {
            type: 'text',
            value: e[i].approvalOpinion,
            label: '审批意见',
          }
          targetObj['id'] = id
          this.approvingFormList.push(targetObj)
        }
      }
    },

    onChange(index) {
      this.index = index
    },
    getContainer1(e) {
      return [...document.getElementsByClassName(e)][0]
    },

    // 获取图片
    getImageUrl(url, id) {
      return utils.getImgUrl(url, id) || this.defaultImage
    },

    // 创建二维码
    getPersonQRCode(data) {
      api.getVisitConfig(150).then(resp => {
        if (resp.data[0].value  === 'true') {
          let qrcode
            qrcode = new QRCode(document.getElementById('qrImg'), {
              width: 120,
              height: 120,
            })
            qrcode.makeCode(data)
            let img = document.getElementById('qrImg').getElementsByTagName('img')[0]
            let canvas = document.getElementById('qrImg').getElementsByTagName('canvas')[0]
            if (canvas) {
              img.src = canvas.toDataURL('image/png')
              img.style.display = 'block'
              canvas.style.display = 'none'
          }
        }
      })

    },

    getTab() {
      api.getTab().then(res =>{
        this.showTab = res.data[0].value
        if(res.data[0].value == 1) {
          this.getDepartmentTree()
        }
      })
    },

    // 选择访问区域
    areaChange() {
      this.formFields['field18'].areaIdList = this.areaIdListTemp;
      let areaNameList = []
      this.formFields['field18'].areaList.map((item) => {
        if (this.formFields['field18'].areaIdList.includes(item.value)) {
          areaNameList.push(item.text)
        }
      })
      this.formFields['field18'].value = areaNameList.join(',')
      this.formFields['field18'].showPicker = false
    },
    // 下一级审核人选择改变
    personChange() {
      console.log('personIdListTemppersonIdListTemp', this.personIdListTemp);
      // if (this.personIdListTemp.length > 1) {
      //   this.$toast('下一级审核人员只可选择一人')
      //   return false
      // }
      let arr = []
      arr.push( this.personIdListTemp)
      // this.formFields['field37'].chooseIdList = this.personIdListTemp;
      this.formFields['field37'].chooseIdList = arr;
      let personNameList = []
      this.formFields['field37'].personList.map((item) => {
        if (this.formFields['field37'].chooseIdList.includes(item.value)) {
          personNameList.push(item.text)
        }
      })
      this.formFields['field37'].value = personNameList.join(',')
      this.formFields['field37'].showPicker = false
    },
    // 关闭访问区域弹弹出层
    closeAreaPopup() {
      this.areaIdListTemp = this.formFields['field18'].areaIdList;
      this.formFields['field18'].showPicker = false;
    },
    // 关闭下一级审核人员弹出层
    closeNextPersonPopup() {

      // this.personIdListTemp = this.formFields['field37'].chooseIdList;
      this.personIdListTemp = this.formFields['field37'].chooseIdList[0];
      this.formFields['field37'].showPicker = false;
    },
    visitorNum111(num) {

      this.followFormList = []
      if (num <= 20 && num >= 2) {
        for (let i = 0; i < num - 1; i++) {
          let id = i + 1
          let targetObj = {}
          targetObj['fieldf' + id + 1] = {
            paramName: 'v_name',
            type: 'text',
            value: '',
            label: '随访人员',
            placeholder: '请输入',
            maxLength: 20,
            require: true,
            isInner: null,
            rules: [
            //   {
            //     pattern: rexp.treeNameRexp,
            //     message: (value) => {
            //       if (value) {
            //         return '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格'
            //       } else {
            //         return '请输入随访人员'
            //       }
            //     },
            //   },
                {
                    required: true,
                    message: '请输入访客姓名',
                },
                {
                    validator: this.validatorNameSpace,
                    message: '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格',
                },
                {
                    pattern: /^[a-zA-Z0-9_@.·\-\s\u4E00-\u9FA5\u3400-\u4DBF]{0,25}$/,
                    message: '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格',
                },
            ],
          }
          targetObj['fieldf' + id + 2] = {
            paramName: 'faceFile',
            type: 'text',
            value: '',
            label: '人脸照片',
            require: this.formFields['field11'].require,
            maxSize: 1024 * 1024 * 4 + '',
            fileList: [],
            rules: [
              {
                //     validator: this.validatorImgA,
                //     message: '请选择人脸照片',
              },
            ],
          }
          targetObj['fieldf' + id + 3] = {
            paramName: 'v_phone',
            type: 'tel',
            value: '',
            label: '联系电话',
            maxLength: 11,
            placeholder: '请输入',
            require: true,
            rules: [
              {
                pattern: rexp.phone,
                message: (value) => {
                  if (value) {
                    return '手机号码格式不正确'
                  } else {
                    return '请输入手机号码'
                  }
                },
              },
            ],
          }
          targetObj['fieldf' + id + 4] = {
            paramName: 'v_plateNumber',
            value: '',
            label: '车牌号码',
            placeholder: '请输入',
            require: false,
            maxLength: 8,
            rules: [
              {
                validator: this.validatorCardIdSpace,
                message: '车牌号存在空格，请重新输入',
              },
              {
                validator: this.validatorCardId, // /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/, //加入新能源车牌
                message: '请输入正确车牌号码',
              },
            ],
          }
          targetObj['fieldf' + id + 5] = {
            paramName: 'v_certificateType',
            value: '身份证',
            label: '证件类型',
            placeholder: '请选择',
            require: true,
            readonly: true,
            showPicker: false,
            columns: [
              {
                id: 'fieldf' + id + 5,
                text: '身份证',
                value: '身份证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '军官证',
                value: '军官证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '学生证',
                value: '学生证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '驾驶证',
                value: '驾驶证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '护照',
                value: '护照',
              },
              {
                id: 'fieldf' + id + 5,
                text: '港澳通行证',
                value: '港澳通行证',
              },
            ],
            rules: [
              {
                  required: true,
                  message: '请选择证件类型',
              },
            ],
          }
          targetObj['fieldf' + id + 6] = {
            paramName: 'v_certificateNumber',
            type: 'text',
            value: '',
            label: '证件号码',
            placeholder: '请输入',
            require: true,
            maxLength: 25,
            rules: [
              {
                required: true,
                message: '请输入证件号码',
              },
              {
                cardTypefield: 'fieldf' + id + 5,
                validator: this.validatorIdCard,
                message: '请输入正确证件号码',
              },
            ],
          }
          targetObj['fieldf' + id + 7] = {
            paramName: 'customMzName',
            text: '',
            value: '',
            label: '民族',
            code: "",
            placeholder: '请选择',
            defaultIndex: 0,
            require: true,
            readonly: true,
            showPicker: false,
            columns: this.dealNation('fieldf' + id + 7),
            rules: [
                {
                    required: true,
                    message: '请选择民族',
                },
            ],
          }
          targetObj['fieldf' + id + 8] = {
            paramName: 'customBankCardNumber',
            value: '',
            label: '银行卡号',
            placeholder: '请输入',
            require: true,
            type: 'text',
            rules: [
                {
                    required: true,
                    message: '请输入银行卡号',
                },
            ],
          }
          targetObj['fieldf' + id + 9] = {
            paramName: 'customBankName',
            value: '',
            label: '开户行名称',
            placeholder: '请输入',
            require: true,
            type: 'text',
            rules: [
                {
                    required: true,
                    message: '请输入开户行名称',
                },
            ],
          }
          targetObj['id'] = id
          this.followFormList.push(targetObj)
        }
      }
    },
    // 来访人数失焦
    visitorNumBlur(e) {
      this.followFormList = []
      if (!this.isFollowerRequired) {
        return false
      }
      let flag = typeof e === 'string'
      let num = flag ? e : Number(e.target.value)
      if (num <= 20 && num >= 2) {
        for (let i = 0; i < num - 1; i++) {
          let id = i + 1
          let targetObj = {}
          targetObj['fieldf' + id + 1] = {
            paramName: 'v_name',
            type: 'text',
            value: flag ? this.followVisitors[i].v_name : '',
            label: '随访人员',
            placeholder: '请输入',
            maxLength: 20,
            require: true,
            isInner: null,
            rules: [
            //   {
            //     pattern: rexp.treeNameRexp,
            //     message: (value) => {
            //       if (value) {
            //         return '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格'
            //       } else {
            //         return '请输入随访人员'
            //       }
            //     },
            //   },
                {
                    required: true,
                    message: '请输入访客姓名',
                },
                {
                    validator: this.validatorNameSpace,
                    message: '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格',
                },
                {
                    pattern: /^[a-zA-Z0-9_@.·\-\s\u4E00-\u9FA5\u3400-\u4DBF]{0,25}$/,
                    message: '仅允许输入汉字、字母、数字与_-·.@字符、非首尾位置的空格',
                },
            ],
          }
          targetObj['fieldf' + id + 2] = {
            paramName: 'faceFile',
            type: 'text',
            value: '',
            label: '人脸照片',
            require: false,
            maxSize: 1024 * 1024 * 4 + '',
            fileList: flag
                ? this.followVisitors[i].v_capturePic
                    ? [{url: this.getImageUrl(this.followVisitors[i].v_capturePic, this.followVisitors[i].id)}]
                    : []
                : [],
            rules: [
              {
                    // validator: this.validatorImgA,
                    // message: '请选择人脸照片',
              },
            ],
          }
          targetObj['fieldf' + id + 3] = {
            paramName: 'v_phone',
            type: 'tel',
            value: flag ? this.followVisitors[i].v_phone : '',
            label: '联系电话',
            maxLength: 11,
            placeholder: '请输入',
            require: true,
            rules: [
              {
                pattern: rexp.phone,
                message: (value) => {
                  if (value) {
                    return '手机号码格式不正确'
                  } else {
                    return '请输入手机号码'
                  }
                },
              },
            ],
          }
          targetObj['fieldf' + id + 4] = {
            paramName: 'v_plateNumber',
            value: flag ? this.followVisitors[i].v_plateNumber : '',
            label: '车牌号码',
            placeholder: '请输入',
            require: false,
            maxLength: 8,
            rules: [
              {
                validator: this.validatorCardIdSpace,
                message: '车牌号存在空格，请重新输入',
              },
              {
                validator: this.validatorCardId, // /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/, //加入新能源车牌
                message: '请输入正确车牌号码',
              },
            ],
          }
          targetObj['fieldf' + id + 5] = {
            paramName: 'v_certificateType',
            value: flag ? this.followVisitors[i].v_certificateType : '身份证',
            label: '证件类型',
            placeholder: '请选择',
            require: true,
            readonly: true,
            showPicker: false,
            columns: [
              {
                id: 'fieldf' + id + 5,
                text: '身份证',
                value: '身份证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '军官证',
                value: '军官证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '学生证',
                value: '学生证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '驾驶证',
                value: '驾驶证',
              },
              {
                id: 'fieldf' + id + 5,
                text: '护照',
                value: '护照',
              },
              {
                id: 'fieldf' + id + 5,
                text: '港澳通行证',
                value: '港澳通行证',
              },
            ],
            rules: [
              {
                  required: true,
                  message: '请选择证件类型',
              },
            ],
          }
          targetObj['fieldf' + id + 6] = {
            paramName: 'v_certificateNumber',
            type: 'text',
            value: flag ? this.followVisitors[i].v_certificateNumber : '',
            label: '证件号码',
            placeholder: '请输入',
            require: true,
            maxLength: 25,
            rules: [
              {
                required: true,
                message: '请输入证件号码',
              },
              {
                cardTypefield: 'fieldf' + id + 5,
                validator: this.validatorIdCard,
                message: '请输入正确证件号码',
              },
            ],
          }
          targetObj['fieldf' + id + 7] = {
            paramName: 'customMzName',
            value: flag ? this.followVisitors[i].customMzName : '',
            label: '民族',
            placeholder: '请选择',
            code: "",
            require: true,
            defaultIndex: 0,
            require: true,
            readonly: true,
            showPicker: false,
            columns: this.dealNation('fieldf' + id + 7),
            rules: [
                {
                    required: true,
                    message: '请选择民族',
                },
            ],
          }
          targetObj['fieldf' + id + 8] = {
            paramName: 'customBankCardNumber',
            value: flag ? this.followVisitors[i].customBankCardNumber : '',
            label: '银行卡号',
            placeholder: '请输入',
            require: true,
            type: 'text',
            rules: [
                {
                    required: true,
                    message: '请输入银行卡号',
                },
            ],
          }
          targetObj['fieldf' + id + 9] = {
            paramName: 'customBankName',
            value: flag ? this.followVisitors[i].customBankName : '',
            label: '开户行名称',
            placeholder: '请输入',
            require: true,
            type: 'text',
            rules: [
                {
                    required: true,
                    message: '请输入开户行名称',
                },
            ],
          }
          targetObj['id'] = id
          this.followFormList.push(targetObj)
        }
      }
      // console.log(this.followFormList)
    },

    // 处理随访人员的民族信息
    dealNation(id) {
        let newNationList = []
        this.nationInfoList.forEach((item,index) => {
            let obj = {
                text: item.text,
                value: item.value,
                id: id,
                index: index,
                paramName: 'customMzName'
            }
            newNationList.push(obj)
        })
        return newNationList
    },

    checkPersonBlur(e) {
      // let params = {
      //     phoneNum: this.formFields['field12'].value,
      //     certificateNumber: this.formFields['field14'].value,
      // }
      // api.checkPerson(params).then((res) => {
      //     this.formFields['field10'].isInner = res.data
      // })
    },

    checkFollowPerson(e, index) {
      // let params = {
      //     phoneNum: this.followFormList[index]['fieldf' + (index + 1) + 3].value,
      //     certificateNumber: this.followFormList[index]['fieldf' + (index + 1) + 6].value,
      // }
      // api.checkPerson(params).then((res) => {
      //     console.log(res, 'res')
      //     this.followFormList[index]['fieldf' + (index + 1) + 1].isInner = res.data
      // })
    },
    /***
     * 当上传结束时，调用文件上传接口
     * @param {Object} args 上传的文件
     * @param {Array} str 文件数组
     ***/
    handleChange(args, str) {
      let {file} = args;

      let acceptType = '.png,.jpg,jpeg,.bmp'
      const acceptArr = acceptType.split(',')
      const nameType = file.name.split('.')
      const type = nameType[nameType.length - 1]
      let count = 0
      acceptArr.map(val => {
        if (this.coverString(type, val)) {
          count++
        }
      })
      if (!count) {
        this.$toast(this.$t('upload.imageTip', [acceptType.replace(/,/g, '、')]))
        return false
      }
      const maxSize = 1024 * 1024 * 4, minSize = 5 * 1024;
      if (file.size > maxSize) {
        this.$toast('图片大小不能超过4M');
        this.initPic(str);
        return false;
      }
      if (file.size < minSize) {
        this.$toast('图片大小不能小于5K');
        this.initPic(str);
        return false;
      }
      const formData = new FormData()
      formData.append('file', file)
      api.uploadFacePic(formData).then(res => {
        //   console.log(res, file, '999--------------')
        if (res.success) {
          if (str.includes('fieldf')) {
            let index = Number(str.substring(6, str.length - 1)) - 1
            this.followFormList[index][str].value = res.data;
          } else {
            this.formFields[str].value = res.data;
            // this.formFields[str].fileList = [{url: this.getImageUrl(res.data)}]
          }
          return true;
        } else {
          this.$toast(this.$t(`visitor.order.errCode${res.code}`));
          return false;
        }
      }).catch(err => {
        let errMsg = err.errMsg || '请重新上传图片！';
        this.initPic(str);
        this.$toast(errMsg);
      })
    },
    initPic(str) {
      if (str.includes('fieldf')) {
        let index = Number(str.substring(6, str.length - 1)) - 1
        this.followFormList[index][str].fileList = [];
      } else {
        this.formFields[str].fileList = [];
      }
    },
    coverString(subStr, str) {
      let reg = new RegExp(subStr, 'ig')
      return reg.test(str)
    },
    //将K转为M
    formatSize(data) {
      let size = this.isNumber(data) + 'K'
      if ((data - 0) >= 1024) {
        size = Math.round(data / 1024) + 'M'
      }
      return size
    },
    //图片类型校验
    beforeReadA(file) {
      let imageType = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp']
      if (imageType.includes(file.type)) {
        return true
      } else {
        this.$toast('请上传 jpg 格式图片')
        return false
      }
    },

    //图片读取成功
    afterReadA(file, str) {
      // let base64=file.content;
      if (str.includes('fieldf')) {
        let index = Number(str.substring(6, str.length - 1)) - 1
        this.followFormList[index][str].value = file.content
      } else {
        this.formFields[str].value = file.content
        return true
      }
    },
    // 删除预览图片
    deleteImg(file, str) {
      if (str.includes('fieldf')) {
        let index = Number(str.substring(6, str.length - 1)) - 1
        this.followFormList[index][str].value = '';
      } else {
        this.formFields[str].value = '';
      }
    },
    //挂载节点
    getContainer() {
      return document.querySelector('.visitType')
    },

    //时间格式
    formatter(type, value) {
      if (type === 'year') {
        return value + '年' //this.t('year')
      }
      if (type === 'month') {
        return value + '月' //this.t('month')
      }
      if (type === 'day') {
        return value + '日' //this.t('day')
      }
      if (type === 'hour') {
        return value + '时' //this.t('hour')
      }
      if (type === 'minute') {
        return value + '分' // this.t('minute')
      }
      if (type === 'second') {
        return value + '秒' //this.t('second')
      }
      return value
    },

    // 被访人员手机格式校验
    isv_phoneValidate(value) {
      if (this.isIntervieweeRequired) {
        if (!value) {
          return false
        } else {
          if (!rexp.phone.test(value)) {
            return false
          } else {
            return true
          }
        }
      } else {
        if (value) {
          if (!rexp.phone.test(value)) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    },

    //phoneNum
    validatorPhoneNum(val) {
      let myreg = /^1[0-9]{10}$}$/
      if (myreg.test(val)) {
        this.show = true
        return true
      } else {
        this.show = false
        return false
      }
    },

    phoneNumChange(value) {
      let phoneNum = value //e.target.value //this.formFields['field1'].value
      let reg = /^[0-9]{11}$/
      if (reg.test(phoneNum)) {
        this.searchDisabled = false
      } else {
        this.searchDisabled = true
      }
      if (!value) {
        this.formFields['field2'].text = ''
        this.formFields['field2'].value = ''
      }
    },

    async phoneNumSearch() {
      if (this.searchDisabled) {
        return
      } else {
        let phone = this.formFields['field1'].value
        // 先获取密钥
        const keyInfo = await getKey()
        if (!keyInfo) {
          this.$toast('获取密钥失败，请重试')
          return
        }
        // 再获取业务数据（传入时间戳）
        api.getIntervieweeNameByPhone(phone, keyInfo.visitorstampKey)
        .then(async (res) => {
          // 最后解密
          const decryptData = await aes_decrypt(res.data, keyInfo)
          if (!decryptData) {
            this.$toast('解密失败，请重试')
            return
          }
          res.data = decryptData
          this.formFields['field2'].text = res.data.name
          this.formFields['field2'].value = res.data.id
          this.isvId = res.data.id
        })
        .catch((err) => {
          this.$toast(err.errMsg)
        })
      }
    },

    jobNumberChange(value){
      if (value) {
        this.searchDisabled = false
      } else {
        this.searchDisabled = true
      }
      if (!value) {
        this.formFields['field30'].text = ''
        this.formFields['field30'].value = ''
      }
    },

    async jobNumberSearch() {
        let jobNum = this.formFields['field29'].value
        // 先获取密钥
        const keyInfo = await getKey()
        if (!keyInfo) {
          this.$toast('获取密钥失败，请重试')
          return
        }
        // 再获取业务数据（传入时间戳）
        api.getIntervieweeNameByCode(jobNum, undefined, keyInfo.visitorstampKey)
        .then(async (res1) => {
          if(res1.data) {
              // 最后解密
              const descData = await aes_decrypt(res1.data, keyInfo)
              if (!descData) {
                this.$toast('解密失败，请重试')
                return
              }
              res1.data = descData
          }
          const res = {
            data: res1.data || {}
          }
          console.log('resresres4', res);
          this.formFields['field30'].text = res.data.name
          this.formFields['field30'].value = res.data.id
          this.isvId = res.data.id
        })
        .catch((err) => {
          this.$toast(err.errMsg)
        })
    },

    //timeToString
    timeToString(timeObj) {
      var str = ''
      var year = timeObj.getFullYear()
      var month = timeObj.getMonth() + 1
      var date = timeObj.getDate()
      var time = timeObj.toTimeString().split(' ')[0].split(':').slice(0, 2).join(':')
      var rex = new RegExp(/:/g)
      str = year + '/' + month + '/' + date + ' ' + time
      return str
    },

    //imageA
    validatorImgA(value) {
      if (value.length) {
        return true
      } else {
        return false
      }
    },

    areaVlidator(value) {
      if (value) {
        return true
      } else {
        return false
      }
    },
    personVlidator(value) {
      if (value) {
        return true
      } else {
        return false
      }
    },

    //车牌号码
    validatorCardId(value) {
      const reg = this.rexp.carNum3
      if (value.length === 0 || reg.test(value)) {
        return true
      } else {
        return false
      }
    },

    // 人员姓名空格校验
    validatorNameSpace(value) {
        let regSpace = /(^\s+|\s+$)/;
        if (!regSpace.test(value)) {
            return true
        } else {
            return false
        }
    },

    // 车牌号码空格校验
    validatorCardIdSpace(value){
        let regSpace = /\s/;
        if (value.length === 0 || !regSpace.test(value)) {
            return true
        } else {
            return false
        }
    },

    //证件号获焦校验
    idFieldFocus(str) {
      if (str.includes('fieldf')) {
        let index = Number(str.substring(6, str.length - 1)) - 1
        if (!this.followFormList[index][str].value.length) {
          this.$toast('请选择证件类型')
        }
      } else {
        if (this.formFields && !this.formFields[str].value.length) {
          this.$toast('请选择证件类型')
        }
      }
    },

    //身份证
    validatorIdCard(value, rule) {
      let str = rule.cardTypefield
      let idType = ''
      if (value.length === 0) {
        return true
      }
      if (str.includes('fieldf')) {
        let index = Number(str.substring(6, str.length - 1)) - 1
        idType = this.followFormList[index][str].value
      } else {
        idType = this.formFields[str].value
      }
      if (idType === '身份证') {
        const reg =
            /^[1-9]\d{7}((0\d)|bai(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
        if (reg.test(value)) {
          return true
        } else {
          return false
        }
      } else {
        const reg = this.rexp.carNum2
        if (reg.test(value)) {
          return true
        } else {
          return false
        }
      }
    },

    onConfirm(obj) {
      console.log(obj);
      if (obj.id.includes('fieldf')) {
        let index = Number(obj.id.substring(6, obj.id.length - 1)) - 1
        this.followFormList[index][obj.id].value = obj.text
        this.followFormList[index][obj.id].showPicker = false
        if (obj.paramName && obj.paramName === "customMzName") {  //随访人员的民族信息
            this.followFormList[index][obj.id].code = obj.value
        }

      } else {
        this.formFields[obj.id].text = obj.text
        this.formFields[obj.id].value = obj.value
        this.formFields[obj.id].showPicker = false
        // 根据访问类型获取访客类型
        if(obj.id === 'field3') {    //更改访客类型
            this.getVisitorType(obj.value)
            console.log(obj.value,"================value=======")
            this.timeType = obj.value
            this.formFields['field4'].value = moment(new Date()).add('minute', 5).format("YYYY/MM/DD HH:mm")
            if(obj.value === '2') {   // 长期访问（来访事由、民族、银行卡号和开户行都为必填）
                this.formFields['field8'].require = true
                this.formFields['field8'].rules = [
                    {
                        required: true,
                        message: '请输入来访事由',
                    },
                ]
                // 当配置为2024-08-01到2025-02-01的时候，后端接口（evo-apigw/evo-visitor/1.0.0/card/visitor/config/152）返回为
                // "data": [
                //     {
                //         "configType": 152,
                //         "parameterName": "long.visitor.config.time",
                //         "valueType": 1,
                //         "value": "08-01###02-01"
                //     }
                // ]
                /**
                 * 离访时间默认值：
                 * 当前时间小于当年2月1日，默认显示当年2月1日
                 * 当前时间大于2月1日小于8月1日，默认显示当年8月1日
                 * 当前时间大于8月1日，默认展示次年2月1日
                 **/
                // 小于当年2月1号
                let smallTime = moment(moment().year() + `/${this.longconfigtime2} 23:59:59`)
                // 当年2月1号到当年8月1号
                let rangeTime =  moment(this.formFields['field4'].value).isBetween(moment().year() + `/${this.longconfigtime2} 23:59:59`, moment().year() + `/${this.longconfigtime1} 00:00:00`, null, '()')
                // 当年8月1号到次年2月1号
                let largeTime = moment(moment().year() + `/${this.longconfigtime1} 00:00:00`)
                // let v_Time = moment(this.formFields['field4'].value).format("YYYY/MM/DD HH:mm:ss")
                let v_Time = moment(this.formFields['field4'].value)
                if (v_Time <= smallTime) {  // 小于等于当年2月1日(2月1号23:59:59)
                    // console.log('111====')
                    this.formFields['field5'].value = moment().year() + `/${this.longconfigtime2} 23:59`
                } else if (rangeTime) {     // 大于2月1日小于8月1日（2月2号00:00:00-8月1号23:59:59）
                    // console.log('222====')
                    this.formFields['field5'].value = moment().year() + `/${this.longconfigtime1} 23:59`
                } else if(v_Time >= largeTime) {  //大于8月1日(8月2号00:00:00)
                    // console.log('333====')
                    this.formFields['field5'].value = (moment().year() + 1) + `/${this.longconfigtime2} 23:59`
                }
                this.leaveTime = this.formFields['field5'].value
            } else {
                // this.formFields['field4'].value = moment(new Date()).add('minute', 5).format("YYYY-MM-DD HH:mm")
                this.formFields['field5'].value = moment(new Date()).hour(23).minute(59).second(0).format("YYYY/MM/DD HH:mm")
                this.formFields['field8'].require = false
                this.formFields['field8'].rules = []
            }
        }
        if (obj.id === 'field6') {
          let arr = []
          arr = this.visitorTypeList.filter(item => {
            return item.value == obj.value
          })
          let param = {
              pageSize: 100, //每页展示的条数
              pageNum: 1, //第几个页码
              searchKey: arr[0].text,
          };
          this.formFields['field18'].areaList = []
          api.getVistorAreaByVisitor(param).then(res => {
            console.log(res)
            res.data.pageData[0].areaIdList.forEach(item => {
              this.visitorAreaOptions.forEach(ele => {
                  if (item == ele.value) {
                    this.formFields['field18'].areaList.push(ele)
                  }
              })
            })
            this.getNextPerson(obj.value)
          })
        }
        if(obj.id === 'field34') {   //民族
            this.formFields['field34'].value = obj.text
            this.formFields['field34'].code = obj.value
            this.customMzCode = obj.value
        }
      }
    },
    arriveClick() {
      if (this.formFields['field3'].value.length === 0) {
        this.$toast('请选择访问类型！')
      } else {
        this.formFields['field4'].showPicker = true
      }
    },

    onConfirmArriveTime(obj) {
        this.obj = obj
        this.formFields['field4'].value = moment(this.timeToString(obj)).format('YYYY/MM/DD HH:mm')
        // this.formFields['field4'].value = this.timeToString(obj)
        this.formFields['field4'].showPicker = false
        // console.log(this.timeToString(obj),"timeType============")
        if(this.timeType === '2') {
            let year = this.timeToString(obj).split('/')[0]
            // let smallTime = moment(year + `/${this.longconfigtime1} 23:59:59`)
            // let rangeTime =  moment(this.formFields['field4'].value).isBetween(year + `/${this.longconfigtime1} 23:59:59`, year + `/${this.longconfigtime2} 00:00:00`, null, '()')
            // let largeTime = moment(year + `/${this.longconfigtime2} 00:00:00`)
            let smallTime = moment(year + `/${this.longconfigtime2} 23:59:59`)
            let rangeTime =  moment(this.formFields['field4'].value).isBetween(year + `/${this.longconfigtime2} 23:59:59`, year + `/${this.longconfigtime1} 00:00:00`, null, '()')
            let largeTime = moment(year + `/${this.longconfigtime1} 00:00:00`)
            let v_Time = moment(this.formFields['field4'].value)
            if (v_Time <= smallTime) {  // 小于等于当年2月1日(2月1号23:59:59)
                this.formFields['field5'].value = year + `/${this.longconfigtime2} 23:59`
            } else if (rangeTime) {     // 大于2月1日小于8月1日（2月2号00:00:00-8月1号23:59:59）
                this.formFields['field5'].value = year + `/${this.longconfigtime1} 23:59`
            } else if(v_Time >= largeTime) {  //大于8月1日(8月2号00:00:00)
                this.formFields['field5'].value = (Number(year) + 1) + `/${this.longconfigtime2} 23:59`
            }
            this.leaveTime = this.formFields['field5'].value
        }else{
            let curYear = moment(this.timeToString(obj)).year();
            let curMonth = moment(this.timeToString(obj)).format('MM');
            let curDay = moment(this.timeToString(obj)).format('DD')
            this.formFields['field5'].value = curYear + '/' + curMonth + '/' + curDay + ' 23:59'
        }
    },

    leaveClick() {
      if (this.formFields['field4'].value.length === 0) {
        this.$toast('请选择来访时间！')
      } else {
        this.$nextTick(() => {
          this.formFields['field5'].showPicker = true
        })
      }
    },
    onCascaderFinish(obj) {
      if (!Object.prototype.hasOwnProperty.call(this.formFields, obj.selectedOptions[obj.tabIndex].parentKey)) {
        this.formFields[obj.selectedOptions[obj.tabIndex].parentKey] = {}
      }
      this.formFields[obj.selectedOptions[obj.tabIndex].parentKey].text = obj.selectedOptions[obj.tabIndex].text
      this.formFields[obj.selectedOptions[obj.tabIndex].parentKey].value = obj.selectedOptions[obj.tabIndex].value
      // this.formFields[obj.selectedOptions[obj.tabIndex].parentKey].showPicker = false
      console.log(obj.selectedOptions[obj.tabIndex].code, '--------------');
      this.getVisitorPerson(obj.selectedOptions[obj.tabIndex].code)
    },
    async getVisitorPerson(code) {
      try {
        // 先获取密钥
        const keyInfo = await getKey()
        if (!keyInfo) {
          this.$toast('获取密钥失败，请重试')
          return
        }
        // 再获取业务数据（传入时间戳）
        const res = await api.getVisitorPerson(code, keyInfo.visitorstampKey);
        if(res.success && res.data) {
          // 最后解密
          const descData = await aes_decrypt(res.data, keyInfo)
          if (!descData) {
            this.$toast('解密失败，请重试')
            return
          }
          this.formFields['field28'].columns = []
          if (descData.list && descData.list.length > 0) {
            descData.list.forEach(item => {
              this.formFields['field28'].columns.push({
                id: 'field28',
                text: item.name,
                value: item.id
              })
            })
          }
         console.log(this.formFields['field28'].columns, '8977645189451623');
        }
      } catch (err) {
        console.log(err)
      }
      // api.getVisitorPerson(code).then(res => {
      //   this.formFields['field28'].columns = []
      //   res.data.list.forEach(item => {
      //     this.formFields['field28'].columns.push({
      //       id: 'field28',
      //       text: item.name,
      //       value: item.id
      //     })
      //   })
      //    console.log(this.formFields['field28'].columns, '8977645189451623');
      // })
    },
    onConfirmleaveTime(obj) {
      console.log(obj)
      let tempLeaveTime = moment(obj)
      let tempArriveTime = moment(this.formFields['field4'].value)
      let year1 = tempArriveTime.year()
      let month1 = tempArriveTime.format('MM')
      let day1 = tempArriveTime.format('DD')
      let defaultLeaveTime = moment(year1 + '/' + month1 + '/' + day1 + ' 23:59:59')
    //   console.log(tempArriveTime > tempLeaveTime,this.timeType,"tempArriveTime===============")
      let year = tempArriveTime.year()
      let month = tempArriveTime.format("MM")
      let day = tempArriveTime.format("DD")
      let time1 = this.formFields['field4'].currentDate
          ? this.formFields['field4'].currentDate.toDateString()
          : 0
      let time2 = this.formFields['field5'].currentDate
          ? this.formFields['field5'].currentDate.toDateString()
          : 0
    //   if(moment(time2) > moment(this.leaveTime)) {
    //       this.$toast('预约时间跨度超过1天')
    //   }
        if (this.timeType === '1') { //临时访问
            if (tempArriveTime > tempLeaveTime) {  //来访时间大于离访时间
                this.formFields['field5'].showPicker = false
                this.formFields['field5'].value = year + '/' + month + '/' + day + ' 23:59'
                // this.$toast('离访时间必须大于来访时间')
                this.$toast({ message: '离访时间必须大于来访时间', duration: 1000 });
            } else if(tempLeaveTime > defaultLeaveTime) { // 离访时间大于来访时间当天的"23:59:59"
                this.formFields['field5'].showPicker = false
                this.formFields['field5'].value = year + '/' + month + '/' + day + ' 23:59'
                this.$toast({ message: '临时访问不支持跨天', duration: 1000 });
            } else {  //正确的情况
                this.formFields['field5'].value = tempLeaveTime.format('YYYY/MM/DD HH:mm')
                this.formFields['field5'].showPicker = false
            }
        } else { //长期访问
            if (tempArriveTime > tempLeaveTime) {  //来访时间大于离访时间
                this.formFields['field5'].showPicker = false
                this.formFields['field5'].value = this.leaveTime
                this.$toast({ message: '离访时间必须大于来访时间', duration: 1000 });
                // this.$toast('离访时间必须大于来访时间')
            } else {   //离访时间大于来访时间
                if(tempLeaveTime > moment(this.leaveTime)) {   // 离访时间大于this.leaveTime
                    this.formFields['field5'].showPicker = false
                    this.formFields['field5'].value = this.leaveTime
                    this.$toast({ message: `长期访问离访时间不能超过${this.leaveTime}`, duration: 2000 });
                    // this.$toast(`长期访问离访时间不能超过${this.leaveTime}`)
                } else {    //离访时间小于this.leaveTime（正确时间范围）
                    this.formFields['field5'].value = tempLeaveTime.format('YYYY/MM/DD HH:mm')
                    this.formFields['field5'].showPicker = false
                }
            }
        }
    },
    canClick() {
      if (this.showTab == 1 &&this.formFields['departmentId'].value) {
        this.formFields['field28'].showPicker = true
      }else {
        this.$toast('请选择所属部门')
      }
    },
    //fieldlist 转 整体obj
    field2Obj(obj) {
      let targetObj = {}
      for (let i in obj) {
        if (typeof obj[i].paramName !== 'undefined' && (obj[i].value + '').length) {
          if (['chargeOrNot'].includes(obj[i].paramName)) {
            targetObj[obj[i].paramName] = obj[i].value
          } else {
            targetObj[obj[i].paramName] = obj[i].value + ''
            if(obj[i].paramName === 'customMzName') {
                targetObj['customMzCode'] = obj[i].code + ''
            }
          }
        }
      }
      return targetObj
    },

    // 邀约表单提交
    onSubmit(values) {
      // console.log(values, 'tijiao==============')
       Toast.loading({
        duration: 0, // 持续展示 toast
        message: '加载中...',
        forbidClick: true,
      });
      this.isDisabled = true
      let paramData = this.field2Obj(this.formFields)
      // 邀约
      let flag = location.href.includes('myVisitorList') || location.href.includes('teacherInvita')
      if (flag) {
        // 用天判断是否为邀约，走邀约流程不需要审核
        paramData.userId = this.v_personid
      }
      paramData.isv_id = this.v_personid ? this.v_personid : this.isvId
      paramData.areaIdList = [...this.formFields['field18'].areaIdList]
      paramData.chooseIdList   = [...this.formFields['field37'].chooseIdList]
      paramData.visitorType = 2
      if(paramData.personName) {
        paramData.isv_id = paramData.personName
      }
      //填充到秒
      let lstr = paramData.v_timeStr.split(' ')[1]
      lstr.split(':').length > 2 ? paramData.v_timeStr = paramData.v_timeStr : paramData.v_timeStr = paramData.v_timeStr  + ':00'
      // paramData.v_timeStr = paramData.v_timeStr + ':00'
      let str = paramData.v_lvTimeStr.split(' ')[1]
      str.split(':').length > 2 ? paramData.v_lvTimeStr = paramData.v_lvTimeStr : paramData.v_lvTimeStr = paramData.v_lvTimeStr  + ':00'
      // paramData.v_lvTimeStr = paramData.v_lvTimeStr  + ':00'
      paramData.v_timeStr = moment(paramData.v_timeStr).format('YYYY-MM-DD HH:mm:ss')
      paramData.v_lvTimeStr = moment(paramData.v_lvTimeStr).format('YYYY-MM-DD HH:mm:ss')
      paramData.followVisitors = []
      if (this.followFormList.length) {
        this.followFormList.forEach((item) => {
          let obj = this.field2Obj(item)
          paramData.followVisitors.push(obj)
        })
      }
      if (this.isEpidemicInfoRequired) {
        paramData.v_healthCodePic = this.picArr[0]
        paramData.v_travelCodePic = this.picArr[1]
      }
       // 处理收费和收费时长逻辑
      if(paramData.v_plateNumber && paramData.v_plateNumber.trim()) {
        if(paramData.chargeOrNot !== 1) {
          delete paramData.freeParkingTimes
        } else {
          paramData.freeParkingTimes = paramData.freeParkingTimes * 60
        }
      } else {
        // 清空是否收费
        delete paramData.chargeOrNot
        delete paramData.freeParkingTimes
      }
      if (paramData.customMzName) {  // 存在民族name，就发送民资code
        paramData.customMzCode = this.customMzCode
      }
      this.openId = this.openId
      paramData.visitorMode = this.visitorMode || '';
      console.log(paramData,"paramData222====================");
      api.addVisitorInfo(paramData)
      .then((res) => {
        if (res.success) {
          this.isDisabled = false
          this.$toast('提交成功')
          res.data.id = this.v_personid //成功页面判断邀约或预约
          res.data.add = this.isvId || 'add'
          res.data.active = 2
          // 提交的时候存储一下当前页面只是“邀约申请”(teacherInvita)还是三个tab都展示的那个页面(myVisitorList)
          // 因为提交成功后，会跳转到成功页面，返回的时候由此可以确定返回到teacherInvita还是myVisitorList页面
          let hash = window.location.hash.split("/")
          sessionStorage.setItem("successBackPage", hash[1])
          this.$router.push({name: 'bookInviteSuccess', params: res.data})
        }
      })
      .catch((err) => {
        this.isDisabled = false
        this.$toast(err.errMsg)
      })
    },

    // 审批不通过
    notAllow() {
      let params = {
        id: this.id,
        visitorType: 2,
        result: false,
        appointTime: this.appointTime,
        isv_id: Number(this.isv_id) || Number(this.isv_id) === 0 ? Number(this.isv_id) : '',
        approvalOpinion: this.formFields['field33'].value,
        personId: localStorage.getItem('v_personid') ? JSON.parse(localStorage.getItem('v_personid')) : '',
      }
      api.review(params)
      .then((res) => {
        this.$toast('操作成功')
        this.$router.go(-1)
      })
      .catch((err) => {
        this.$toast(err.errMsg)
      })
    },

    // 防疫开关未开启审批通过
    allow() {
      let areaIdList = [...this.formFields['field18'].areaIdList]
      if (!areaIdList.length) {
        return this.$toast('请选择访问区域')
      }
      if (this.isEpidemicInfoRequired && this.v_healthCodePic) {
        this.show = true
      } else {
        let params = {
          id: this.id,
          visitorType: 2,
          result: true,
          appointTime: new Date(this.appointTime).getTime(),
          areaIdList,
          times: this.formFields['field7'].value,
          secondVisitorType: this.formFields['field6'].value,
          personId: localStorage.getItem('v_personid') ? JSON.parse(localStorage.getItem('v_personid')) : '',
          approvalOpinion: this.formFields['field33'].value
        }
        api.review(params)
        .then((res) => {
          this.$toast('操作成功')
          this.$router.go(-1)
        })
        .catch((err) => {
          this.$toast(err.errMsg)
        })
      }
    },
    // 获取部门树数据
    async getDepartmentTree(){
      try {
        // 先获取密钥
        const keyInfo = await getKey()
        if (!keyInfo) {
          this.$toast('获取密钥失败，请重试')
          return
        }
        // 再获取业务数据（传入时间戳）
        const res = await api.getOrgCode(undefined, keyInfo.visitorstampKey);
        if(res.success && res.data) {
          // 最后解密
          const descData = await aes_decrypt(res.data, keyInfo)
          if (descData && Array.isArray(descData)) {
            this.treeDataFilter(descData)
          } else {
            this.treeDataFilter([])
          }
        }
      } catch (err) {
        console.log(err)
      }
      // api.getOrgCode().then((res) => {
      //   if (res.success) {
      //     // 格式化树数据
      //     this.treeDataFilter(res.data || [])
      //   }
      //   console.log(res)
      // })
    },
    // 格式化树数据
    treeDataFilter(data, init = true) {
      data.sort((a,b)=>{
          return( a.id - b.id)
      })
      if (init) {
        this.treeDataObject = {}
      }
      data.forEach((item, index) => {
        if (!Object.prototype.hasOwnProperty.call(this.treeDataObject, item.id)) {
          if (item.hasChild) {
            item.children = []
          }
          item.parentKey = 'departmentId'
          item.text = item.name
          item.value = item.id
          this.treeDataObject[item.id] = item
        }
        if (Object.prototype.hasOwnProperty.call(this.treeDataObject, item.parentId)) {
          this.treeDataObject[item.parentId].children.push(item)
        }
      });
      // 根据treeDataObject生成treeDataList
      this.treeDataList = [this.treeDataObject[1]]
      console.log(this.treeDataList);
    },
    departmentChange(obj) {
      let data = obj.selectedOptions[obj.tabIndex]
      this.formFields.departmentId.value = data.id
      this.formFields['departmentId'].text = data.text
      this.formFields['field28'].columns = []
      this.formFields['field28'].text = ''
       if (!Object.prototype.hasOwnProperty.call(this.formFields, obj.selectedOptions[obj.tabIndex].parentKey)) {
        this.formFields[obj.selectedOptions[obj.tabIndex].parentKey] = {}
      }
      this.formFields[obj.selectedOptions[obj.tabIndex].parentKey].text = obj.selectedOptions[obj.tabIndex].text
      this.formFields[obj.selectedOptions[obj.tabIndex].parentKey].value = obj.selectedOptions[obj.tabIndex].value
      // this.formFields[obj.selectedOptions[obj.tabIndex].parentKey].showPicker = false
      this.getVisitorPerson(obj.selectedOptions[obj.tabIndex].code)
    },
    // 防疫开关开启确认审核通过，关闭详情弹框、返回列表页面
    onReviewConfirm() {
      let areaIdList = [...this.formFields['field18'].areaIdList]
      let params = {
        id: this.id,
        visitorType: 2,
        result: true,
        areaIdList,
      }
      api.review(params)
      .then((res) => {
        this.$toast('操作成功')
        this.$router.go(-1)
      })
      .catch((err) => {
        this.$toast(err.errMsg)
      })
    },

    // 取消审核关闭防疫详情弹框
    onReviewCancel() {
      console.log('取消')
    },
  },
}
</script>
<style lang="less" scoped>
::v-deep .carNumber .hua-field__control::placeholder{
  font-size: 11px;
}
.header-text{
    width: 25%;
    color: #1a66c7
}
.cropper-bg{
    background-image: url('../../../image/faceCover.png');
    background-repeat:no-repeat;
    background-size:100% 75%;
    height:calc(100% - 1rem);
    width:100%;
    position:absolute;
    top:1rem;
    bottom:0;
    left:0;
    right:0;
    z-index:99999;
    pointer-events:none;
    text-align: center;
    font-size: 14px;
    color: #ccc;
}

.v_info_x {
  width: 100%;

  .v_info {
    .info_title {
      color: #007aff;
      padding-left: 0.17rem;
      font-size: 0.14rem;
      line-height: 0.33rem;
    }
    .icon-title {
        display: flex;
        align-items: center;
        img {
            margin-top: -2px;
            margin-right: 5px;
            width: 15px;
        }
    }

    .info_tip {
      color: #f00;
      padding-left: 0.12rem;
      font-size: 0.1rem;
      line-height: 0.3rem;
    }

    .disableSearch {
      color: #c8c9cc;
    }

    .activeSearch {
      color: #1989fa;
    }


    .followSpace {
      width: 100%;
      height: 0.2rem;
      background-color: #f6f6f6;
    }

    .face-img{
        .hua-field__label {
            width:20% !important;
        }
        .img-tips {
            width: 120%;
            // background: yellow;
            position: absolute;
            right: 5px;
            // left: 0;
            bottom: -14px;
            font-size: 11px;
            text-shadow: 0 0 0 #c5cdd6;
        }
    }
  }

  .detail-qrcode {
    text-align: center;
    padding: 30px 20px 10px;
    background-color: #fff;

    .success-code {
      color: #181818;
      font-size: 18px;
      margin-top: 15px;
    }

    .success-tip {
      margin: 20px 40px;
      color: #8c8c8c;
    }

    .qrImg {
      img {
        margin: auto;
      }
    }

    .bottom-tip {
      margin: 20px 60px 30px;
    }
  }

  .visitType {
    .hua-popover__content {
      width: 2.3rem;
      height: 0.4rem;

      .hua-popover__action {
        height: 0.4rem;
        font-size: 0.12rem;
        line-height: 0.22rem;
      }
    }
  }

  .hua-cell {
    align-items: center;
  }

  .customContent {
    height: 350px;
    overflow-y: auto;

    .area-content-title {
      padding: 10px 15px;
      height: 35px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > :nth-child(1) {
        color: #8c8c8c;
      }

      > :nth-child(2) {
        font-size: 16px;
      }

      > :nth-child(3) {
        color: #1989fa;
      }
    }
  }

  .btn-box {
    margin: 10px 0;
    padding: 15px;
    background-color: #fff;
    display: flex;
  }

  .btn-box-no {
    margin: 16px;

    .hua-button {
      width: 100%;
    }
  }

  .prevstep {
    width: 30%;
    border-color: #1989fa;
  }

  .pass-fail {
    width: 30%;
    border-color: #f00;

    .hua-button__text {
      color: red;
    }
  }

  .submit {
    flex: 1;
    margin-left: 15px;
  }

  .hua-image-preview {
    top: 55px;
    height: 350px;
  }
  .hua-uploader__mask {
    background-color: transparent !important;
  }
}
</style>
<style lang="less" scoped>
.my-wrapper {
    background-color: #f4f5f6;
    .form-block {
      border-radius: 10px;
      margin: 0 10px;
      overflow: hidden;
      .visit-reason {
          align-items: flex-start;
          /deep/ .hua-field__body {
              border-radius: 10px;
              padding: 5px;
              background-color: #f9f9f9;
          }
      }
    }
}
</style>
